import { withTheme } from 'emotion-theming';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import createEmotionStyled from 'create-emotion-styled';
import createEmotion from 'create-emotion';
import styled$1 from 'react-emotion';

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

var LoadingOutlineSmallIcon = function LoadingOutlineSmallIcon(_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, props), React.createElement("path", {
    d: "M17.62 6.306L15.406 8.52a4.87 4.87 0 1 0 0 6.96l2.214 2.214a8 8 0 1 1 0-11.388z"
  }));
};

var breakpoints = {
  xs1: '0',
  xs2: '480px',
  sm1: '540px',
  sm2: '640px',
  md1: '768px',
  md2: '960px',
  lg1: '1024px',
  lg2: '1280px',
  lg3: '1328px',
  xl1: '1420px',
  xl2: '1920px'
};

var getMediaQuery = function getMediaQuery(css, breakpoint) {
  return '@media (min-width: ' + breakpoint + ') { ' + css + ' }';
};

var breakpointAndUp = {};

var _loop = function _loop(_breakpoint2) {
  if (breakpoints[_breakpoint2] !== '0') {
    breakpointAndUp[_breakpoint2] = function (css) {
      return getMediaQuery(css, breakpoints[_breakpoint2]);
    };
  }
};

for (var _breakpoint2 in breakpoints) {
  _loop(_breakpoint2);
}

var theme = {
  baseFontSize: 16
}; //DEBTxCYBG pull this from theme component or global?

var baseSpacing = 8;

var spacingHelper = function spacingHelper(value) {
  var fontMultiple = value * baseSpacing;
  var rems = fontMultiple / theme.baseFontSize;
  return rems + 'rem';
};

var spacing = {
  EIGHTH: spacingHelper(0.125),
  QUARTER: spacingHelper(0.25),
  HALF: spacingHelper(0.5),
  THREE_QUARTERS: spacingHelper(0.75),
  SINGLE: spacingHelper(1),
  ONE_AND_QUARTER: spacingHelper(1.25),
  ONE_AND_HALF: spacingHelper(1.5),
  ONE_AND_THREE_QUARTERS: spacingHelper(1.75),
  DOUBLE: spacingHelper(2),
  TWO_AND_HALF: spacingHelper(2.5),
  TRIPLE: spacingHelper(3),
  THREE_AND_HALF: spacingHelper(3.5),
  QUADRUPLE: spacingHelper(4),
  QUINTUPLE: spacingHelper(5),
  SEXTUPLE: spacingHelper(6),
  SEPTUPLE: spacingHelper(7),
  OCTUPLE: spacingHelper(8),
  NONUPLE: spacingHelper(9),
  DECUPLE: spacingHelper(10)
};
var externalMarginRegular = '\n    margin-right: ' + spacing.DOUBLE + ';\n    margin-bottom: ' + spacing.DOUBLE + ';\n';
var internalPaddingShell = '\n    overflow: auto;\n    padding-bottom: ' + spacing.SINGLE + '; \n    padding-left: ' + spacing.DOUBLE + '; \n    padding-right: 0; \n    padding-top: ' + spacing.DOUBLE + ';\n    ' + breakpointAndUp.md1('\n        padding-left: ' + spacing.TRIPLE + ';\n        padding-right: ' + spacing.SINGLE + ';\n    ') + '\n';
/* Font size config: usage example ${fontSize('arran')} */

var fontConfig = {
  lewis: {
    xs1: {
      fontSize: 37,
      lineHeight: 1.189
    },
    sm1: {
      fontSize: 37,
      lineHeight: 1.189
    },
    md1: {
      fontSize: 45,
      lineHeight: 1.067
    },
    lg1: {
      fontSize: 52,
      lineHeight: 1.154
    },
    xl1: {
      fontSize: 52,
      lineHeight: 1.154
    }
  },
  skye: {
    xs1: {
      fontSize: 32,
      lineHeight: 1.125
    },
    sm1: {
      fontSize: 32,
      lineHeight: 1.125
    },
    md1: {
      fontSize: 40,
      lineHeight: 1.1
    },
    lg1: {
      fontSize: 45,
      lineHeight: 1.156
    },
    xl1: {
      fontSize: 45,
      lineHeight: 1.156
    }
  },
  shetland: {
    xs1: {
      fontSize: 29,
      lineHeight: 1.241
    },
    sm1: {
      fontSize: 29,
      lineHeight: 1.241
    },
    md1: {
      fontSize: 34,
      lineHeight: 1.176
    },
    lg1: {
      fontSize: 39,
      lineHeight: 1.128
    },
    xl1: {
      fontSize: 39,
      lineHeight: 1.128
    }
  },
  mull: {
    xs1: {
      fontSize: 26,
      lineHeight: 1.231
    },
    sm1: {
      fontSize: 26,
      lineHeight: 1.231
    },
    md1: {
      fontSize: 29,
      lineHeight: 1.241
    },
    lg1: {
      fontSize: 33,
      lineHeight: 1.212
    },
    xl1: {
      fontSize: 33,
      lineHeight: 1.212
    }
  },
  islay: {
    xs1: {
      fontSize: 23,
      lineHeight: 1.217
    },
    sm1: {
      fontSize: 23,
      lineHeight: 1.217
    },
    md1: {
      fontSize: 25,
      lineHeight: 1.28
    },
    lg1: {
      fontSize: 28,
      lineHeight: 1.286
    },
    xl1: {
      fontSize: 28,
      lineHeight: 1.286
    }
  },
  orkney: {
    xs1: {
      fontSize: 20,
      lineHeight: 1.4
    },
    sm1: {
      fontSize: 20,
      lineHeight: 1.4
    },
    md1: {
      fontSize: 22,
      lineHeight: 1.273
    },
    lg1: {
      fontSize: 25,
      lineHeight: 1.28
    },
    xl1: {
      fontSize: 25,
      lineHeight: 1.28
    }
  },
  arran: {
    xs1: {
      fontSize: 18,
      lineHeight: 1.333
    },
    sm1: {
      fontSize: 18,
      lineHeight: 1.333
    },
    md1: {
      fontSize: 19,
      lineHeight: 1.474
    },
    lg1: {
      fontSize: 21,
      lineHeight: 1.333
    },
    xl1: {
      fontSize: 21,
      lineHeight: 1.333
    }
  },
  jura: {
    xs1: {
      fontSize: 16,
      lineHeight: 1.5
    },
    sm1: {
      fontSize: 16,
      lineHeight: 1.5
    },
    md1: {
      fontSize: 16,
      lineHeight: 1.5
    },
    lg1: {
      fontSize: 18,
      lineHeight: 1.556
    },
    xl1: {
      fontSize: 18,
      lineHeight: 1.556
    }
  },
  uist: {
    xs1: {
      fontSize: 14,
      lineHeight: 1.429
    },
    sm1: {
      fontSize: 14,
      lineHeight: 1.429
    },
    md1: {
      fontSize: 14,
      lineHeight: 1.429
    },
    lg1: {
      fontSize: 16,
      lineHeight: 1.5
    },
    xl1: {
      fontSize: 16,
      lineHeight: 1.5
    }
  },
  bute: {
    xs1: {
      fontSize: 12,
      lineHeight: 1.333
    },
    sm1: {
      fontSize: 12,
      lineHeight: 1.333
    },
    md1: {
      fontSize: 13,
      lineHeight: 1.538
    },
    lg1: {
      fontSize: 13,
      lineHeight: 1.538
    },
    xl1: {
      fontSize: 13,
      lineHeight: 1.538
    }
  },
  cumbrae: {
    xs1: {
      fontSize: 11,
      lineHeight: 1.455
    },
    sm1: {
      fontSize: 11,
      lineHeight: 1.455
    },
    md1: {
      fontSize: 12,
      lineHeight: 1.333
    },
    lg1: {
      fontSize: 12,
      lineHeight: 1.333
    },
    xl1: {
      fontSize: 12,
      lineHeight: 1.333
    }
  }
};

var generateSASS = function generateSASS(mqBreakpoint, size, lineHeight) {
  var styles = '';

  if (parseInt(mqBreakpoint) === 0) {
    styles = 'font-size: ' + size + 'px; line-height: ' + lineHeight + ';';
  } else {
    styles = '\n      @media (min-width: ' + mqBreakpoint + ') {\n        font-size: ' + size + 'px;\n        line-height: ' + lineHeight + ';\n      } \n    ';
  }

  return styles;
};

var fontSizes = {};

for (var _fontSize in fontConfig) {
  if (fontConfig.hasOwnProperty(_fontSize)) {
    var style = '';

    for (var breakpoint in fontConfig[_fontSize]) {
      if (fontConfig[_fontSize].hasOwnProperty(breakpoint)) {
        var _fontConfig$_fontSize = fontConfig[_fontSize][breakpoint],
            size = _fontConfig$_fontSize.fontSize,
            lineHeight = _fontConfig$_fontSize.lineHeight;
        style += generateSASS(breakpoints[breakpoint], size, lineHeight);
      }
    }

    fontSizes[_fontSize] = style;
  }
}

var fontSize = function fontSize(font) {
  return fontSizes[font];
};

var useFontSize = {
  of: {
    lewis: function lewis() {
      return fontSizes['lewis'];
    },
    skye: function skye() {
      return fontSizes['skye'];
    },
    shetland: function shetland() {
      return fontSizes['shetland'];
    },
    mull: function mull() {
      return fontSizes['mull'];
    },
    islay: function islay() {
      return fontSizes['islay'];
    },
    orkney: function orkney() {
      return fontSizes['orkney'];
    },
    arran: function arran() {
      return fontSizes['arran'];
    },
    jura: function jura() {
      return fontSizes['jura'];
    },
    uist: function uist() {
      return fontSizes['uist'];
    },
    bute: function bute() {
      return fontSizes['bute'];
    },
    cumbrae: function cumbrae() {
      return fontSizes['cumbrae'];
    }
  },
  biggerThan: {
    lewis: function lewis() {
      throw new Error("lewis is the biggest font");
    },
    skye: function skye() {
      return fontSizes['lewis'];
    },
    shetland: function shetland() {
      return fontSizes['skye'];
    },
    mull: function mull() {
      return fontSizes['shetland'];
    },
    islay: function islay() {
      return fontSizes['mull'];
    },
    orkney: function orkney() {
      return fontSizes['islay'];
    },
    arran: function arran() {
      return fontSizes['orkney'];
    },
    jura: function jura() {
      return fontSizes['arran'];
    },
    uist: function uist() {
      return fontSizes['jura'];
    },
    bute: function bute() {
      return fontSizes['uist'];
    },
    cumbrae: function cumbrae() {
      return fontSizes['bute'];
    }
  },
  smallerThan: {
    lewis: function lewis() {
      return fontSizes['skye'];
    },
    skye: function skye() {
      return fontSizes['shetland'];
    },
    shetland: function shetland() {
      return fontSizes['mull'];
    },
    mull: function mull() {
      return fontSizes['islay'];
    },
    islay: function islay() {
      return fontSizes['orkney'];
    },
    orkney: function orkney() {
      return fontSizes['arran'];
    },
    arran: function arran() {
      return fontSizes['jura'];
    },
    jura: function jura() {
      return fontSizes['uist'];
    },
    uist: function uist() {
      return fontSizes['bute'];
    },
    bute: function bute() {
      return fontSizes['cumbrae'];
    },
    cumbrae: function cumbrae() {
      throw new Error("cumbrae is the smallest font");
    }
  }
};
var context = typeof global !== 'undefined' ? global : {};

var _createEmotion = createEmotion(context, {
  nonce: btoa('web-ui-components')
}),
    caches = _createEmotion.caches,
    css = _createEmotion.css,
    cx = _createEmotion.cx,
    flush = _createEmotion.flush,
    getRegisteredStyles = _createEmotion.getRegisteredStyles,
    hydrate = _createEmotion.hydrate,
    injectGlobal = _createEmotion.injectGlobal,
    keyframes = _createEmotion.keyframes,
    merge = _createEmotion.merge,
    sheet = _createEmotion.sheet;

var emotion = /*#__PURE__*/Object.freeze({
  __proto__: null,
  caches: caches,
  css: css,
  cx: cx,
  flush: flush,
  getRegisteredStyles: getRegisteredStyles,
  hydrate: hydrate,
  injectGlobal: injectGlobal,
  keyframes: keyframes,
  merge: merge,
  sheet: sheet
});
var styled = createEmotionStyled(emotion, React);

var classCallCheck = function classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _extends$1 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits = function inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var possibleConstructorReturn = function possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var taggedTemplateLiteral = function taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
};

var HSL_SLICE_START = 4;
var DEFAULT_AMOUNT = 5;

var hslAdjust = function hslAdjust(hslText) {
  var splitHSL = hslText.slice(HSL_SLICE_START, hslText.length - 1).split(',');

  var _splitHSL = slicedToArray(splitHSL, 3),
      hueLabel = _splitHSL[0],
      saturationLabel = _splitHSL[1],
      lightnessLabel = _splitHSL[2];

  var hue = parseInt(hueLabel, 10);
  var saturation = parseInt(saturationLabel.slice(0, saturationLabel.length - 1), 10);
  var lightness = parseInt(lightnessLabel.slice(0, lightnessLabel.length - 1), 10);
  return {
    darken: function darken() {
      var amount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_AMOUNT;
      return 'hsl(' + hue + ', ' + saturation + '%, ' + (lightness - amount) + '%)';
    },
    lighten: function lighten() {
      var amount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_AMOUNT;
      return 'hsl(' + hue + ', ' + saturation + '%, ' + (lightness + amount) + '%)';
    },
    saturate: function saturate() {
      var amount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_AMOUNT;
      return 'hsl(' + hue + ', ' + (saturation + amount) + '%, ' + lightness + '%)';
    },
    desaturate: function desaturate() {
      var amount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_AMOUNT;
      return 'hsl(' + hue + ', ' + (saturation - amount) + '%, ' + lightness + '%)';
    }
  };
};

var _templateObject = taggedTemplateLiteral(['\n  0% {\n    box-shadow: 0 0 0 0 rgba(121, 0, 202, 0.8);\n  }\n  100% {\n    box-shadow: 0 0 0 ', ' rgba(121, 0, 202, 0);\n  }\n'], ['\n  0% {\n    box-shadow: 0 0 0 0 rgba(121, 0, 202, 0.8);\n  }\n  100% {\n    box-shadow: 0 0 0 ', ' rgba(121, 0, 202, 0);\n  }\n']),
    _templateObject2 = taggedTemplateLiteral(['\n  0% {\n    box-shadow: 0 0 0 0 rgba(248, 0, 0, 0.8);\n  }\n  100% {\n    box-shadow: 0 0 0 ', ' rgba(248, 0, 0, 0);\n  }\n'], ['\n  0% {\n    box-shadow: 0 0 0 0 rgba(248, 0, 0, 0.8);\n  }\n  100% {\n    box-shadow: 0 0 0 ', ' rgba(248, 0, 0, 0);\n  }\n']),
    _templateObject3 = taggedTemplateLiteral(['\n  0% {\n    box-shadow: 0 0 0 0 rgba(0, 148, 211, 0.8);\n  }\n  100% {\n    box-shadow: 0 0 0 ', ' rgba(0, 148, 211, 0);\n  }\n'], ['\n  0% {\n    box-shadow: 0 0 0 0 rgba(0, 148, 211, 0.8);\n  }\n  100% {\n    box-shadow: 0 0 0 ', ' rgba(0, 148, 211, 0);\n  }\n']),
    _templateObject4 = taggedTemplateLiteral(['\n  0% {\n    opacity: 0;\n  }\n  25% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n'], ['\n  0% {\n    opacity: 0;\n  }\n  25% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n']),
    _templateObject5 = taggedTemplateLiteral(['\n  0% {\n    opacity: 1;\n  }\n  25% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 0;\n  }\n'], ['\n  0% {\n    opacity: 1;\n  }\n  25% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 0;\n  }\n']),
    _templateObject6 = taggedTemplateLiteral(['\n  from {\n    fill: ', ';\n  }\n  to {\n    fill: ', ';\n  }\n'], ['\n  from {\n    fill: ', ';\n  }\n  to {\n    fill: ', ';\n  }\n']),
    _templateObject7 = taggedTemplateLiteral(['\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n'], ['\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n']),
    _templateObject8 = taggedTemplateLiteral(['\n  0% {\n    transform: scale(0.8);\n  }\n  65.5% {\n    transform: scale(1.03);\n  }\n  100% {\n    transform: scale(1);\n  }\n'], ['\n  0% {\n    transform: scale(0.8);\n  }\n  65.5% {\n    transform: scale(1.03);\n  }\n  100% {\n    transform: scale(1);\n  }\n']);

var circularPulseB = keyframes(_templateObject, spacing.QUADRUPLE);
var circularPulseCB = keyframes(_templateObject2, spacing.QUADRUPLE);
var circularPulseYB = keyframes(_templateObject3, spacing.QUADRUPLE);
var fadeIn = keyframes(_templateObject4);
var fadeOut = keyframes(_templateObject5);

var iconPulse = function iconPulse(colour) {
  return keyframes(_templateObject6, colour, hslAdjust(colour).lighten(0.2));
};

var rotate = keyframes(_templateObject7);
var scaleFadeIn = keyframes(_templateObject8);
var animations = {
  circularPulseB: circularPulseB,
  circularPulseCB: circularPulseCB,
  circularPulseYB: circularPulseYB,
  fadeIn: fadeIn,
  fadeOut: fadeOut,
  iconPulse: iconPulse,
  rotate: rotate,
  scaleFadeIn: scaleFadeIn
};
var generalPalette = {
  black: 'hsl(0, 0%, 0%)',
  blue: 'hsl(204, 52%, 48%)',
  blueLight: 'hsl(208, 59%, 60%)',
  green: 'hsl(135, 41%, 48%)',
  greenFaint: 'hsl(135, 41%, 70%)',
  greyDarkest: 'hsl(0, 0%, 28%)',
  greyDarker: 'hsl(0, 0%, 42%)',
  grey: 'hsl(0, 0%, 60%)',
  greyLighter: 'hsl(0, 0%, 75%)',
  greyLightest: 'hsl(0, 0%, 85%)',
  orange: 'hsl(29, 77%, 56%)',
  red: 'hsl(8, 52%, 50%)',
  purple: 'hsl(282, 25%, 57%)',
  white: 'hsl(0, 0%, 100%)'
};
var black = generalPalette.black,
    blue = generalPalette.blue,
    blueLight = generalPalette.blueLight,
    green = generalPalette.green,
    greenFaint = generalPalette.greenFaint,
    greyDarker = generalPalette.greyDarker,
    greyDarkest = generalPalette.greyDarkest,
    greyLightest = generalPalette.greyLightest,
    orange = generalPalette.orange,
    red = generalPalette.red,
    grey = generalPalette.grey,
    greyLighter = generalPalette.greyLighter,
    purple = generalPalette.purple,
    white = generalPalette.white;
var colours = {
  backgrounds: {
    alternateBody: 'hsl(212, 100%, 97%)',
    alternateHeader: greyLightest,
    component: white,
    modalBackdrop: black,
    modalBackdropOpaque: 'rgba(0, 0, 0, 0.8)',
    shell: 'hsl(0, 0%, 95.3%)',
    tableCell: 'hsl(0, 0%, 97%)',
    tableCellAlternate: 'hsl(0, 71%, 97%)',
    tableCellHeader: 'hsl(0, 0%, 94%)'
  },
  component: {
    frame: {
      active: {
        background: 'repeating-linear-gradient(45deg, hsl(45, 0%, 75%), ' + 'hsl(45, 0%, 75%) 28px, hsl(46, 0%, 95%) 28px, hsl(46, 0%, 95%) 56px)',
        content: 'hsl(45, 0%, 75%)'
      },
      deprecated: {
        background: 'repeating-linear-gradient(45deg, hsl(45, 100%, 46%), ' + 'hsl(45, 100%, 46%) 28px, hsl(46, 100%, 64%) 28px, hsl(46, 100%, 64%) 56px)',
        content: 'hsl(45, 100%, 46%)'
      },
      draft: {
        background: 'repeating-linear-gradient(45deg, hsl(204, 52%, 48%), ' + 'hsl(204, 52%, 48%) 28px, hsl(205, 52%, 58%) 28px, hsl(205, 52%, 58%) 56px)',
        content: 'hsl(204, 52%, 48%)'
      },
      outdated: {
        background: 'repeating-linear-gradient(45deg, hsl(269, 69%, 69%), ' + 'hsl(269, 69%, 69%) 28px, hsl(270, 69%, 79%) 28px, hsl(270, 69%, 79%) 56px)',
        content: 'hsl(269, 69%, 69%)'
      }
    },
    border: greyLightest,
    hover: greyLightest,
    locked: greyDarker
  },
  disabled: {
    background: greyLightest,
    border: greyDarkest
  },
  neutral: {
    black: black,
    grey: grey,
    greyDarker: greyDarker,
    greyDarkest: greyDarkest,
    greyLighter: greyLighter,
    greyLightest: greyLightest,
    white: white
  },
  telephony: {
    answerCallGradient: 'linear-gradient(hsl(54, 100%, 73%), hsl(49, 99%, 64%));',
    calledGradient: 'linear-gradient(hsl(159, 52%, 67%), hsl(153, 41%, 49%));',
    conferenceCallGradient: 'linear-gradient(hsl(193, 100%, 91%), hsl(196, 96%, 80%));',
    conferenceMaskGradient: 'linear-gradient(hsl(248, 86%, 83%), hsl(260, 94%, 72%));',
    dialingCallGradient: 'linear-gradient(hsl(54, 100%, 73%), hsl(49, 99%, 64%));',
    holdCallGradient: 'linear-gradient(hsl(45, 95%, 75%), hsl(37, 91%, 65%));',
    makeCallGradient: 'linear-gradient(hsl(33, 15%, 86%), hsl(180, 3%, 69%));',
    onCallGradient: 'linear-gradient(hsl(129, 80%, 82%), hsl(127, 67%, 63%));',
    answerCall: 'hsl(89, 91%, 40%)',
    closeCall: 'hsl(353, 98%, 41%)',
    dialCall: 'hsl(89, 91%, 40%)',
    endCall: 'hsl(353, 98%, 41%)',
    holdCall: 'hsl(37, 94%, 49%)',
    resumeCall: 'hsl(89, 91%, 40%)'
  },
  typography: {
    body: greyDarkest,
    supplementaryBody: grey
  },
  utility: {
    active: green,
    archived: greyLightest,
    blocker: 'hsl(0, 60%, 96%)',
    deprecated: 'hsl(45, 100%, 51%)',
    empty: 'hsl(0, 0%, 100%)',
    emptyBorder: 'hsl(0, 0%, 40%)',
    error: red,
    errorBodyBackground: 'hsl(8,52%,96%)',
    focus: blueLight,
    help: 'hsl(210, 38%, 91%)',
    inactive: red,
    indicative: orange,
    information: blue,
    notStarted: greyDarker,
    off: grey,
    offDisabled: greyLighter,
    ongoing: purple,
    paused: blue,
    pending: orange,
    success: green,
    successDisabled: greenFaint,
    warning: orange
  },
  utilityLegacy: {
    infoBackground: 'hsl(210, 46%, 91%)',
    infoBorder: 'hsl(204, 52%, 48%)',
    noteBackground: 'hsl(45, 53%, 94%)',
    noteBorder: 'hsl(46, 88%, 24%)',
    tipBackground: 'hsl(125, 21%, 88%)',
    tipBorder: 'hsl(135, 41%, 48%)',
    warningBackground: 'hsl(0, 60%, 96%)',
    warningBorder: 'hsl(8, 52%, 50%)'
  },
  // TODOxVM: Colours are getting a proper revisit soon. This is temporary. 
  utilitySupremacy: {
    guidancePrimary: 'hsl(210, 97%, 87%)',
    guidanceSecondary: 'hsl(210, 100%, 95%)',
    importantPrimary: 'hsl(0, 96%, 77%)',
    importantSecondary: 'hsl(360, 60%, 96%)',
    rememberPrimary: 'hsl(55, 92%, 69%)',
    rememberSecondary: 'hsl(55, 100%, 88%)',
    successPrimary: 'hsl(144, 83%, 25%)',
    successSecondary: 'hsl(90, 91%, 88%)',
    validationPrimary: 'hsl(4, 72%, 47%)',
    validationSecondary: 'hsl(0, 58%, 96%)'
  }
};

var _extends$2 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties$1(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

var VMIcon = function VMIcon(_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$1(_ref, ["styles"]);

  return React.createElement("svg", _extends$2({
    height: "96",
    viewBox: "0 0 96 96",
    width: "96",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), React.createElement("path", {
    d: "M84 96H56c-.238 0-.475-.02-.709-.062a31.449 31.449 0 0 1-2.518-.56A17.923 17.923 0 0 1 48 93.325a18.772 18.772 0 0 1-7.377 2.63c-.168.019-.453.046-.623.046H12a4 4 0 0 1-4-4V44a8.21 8.21 0 0 1 8-8h8V24C24 10.745 34.745 0 48 0s24 10.745 24 24v8h-8v-8c0-8.837-7.163-16-16-16s-16 7.163-16 16v16a3.999 3.999 0 0 1-4 4H16v44h23.74a10.522 10.522 0 0 0 2.153-.55 21.577 21.577 0 0 1-.825-1.317L34.23 74.246a15.892 15.892 0 0 1 13.846-23.754h.002a15.866 15.866 0 0 1 13.793 23.781l-6.91 11.899c-.252.437-.52.86-.8 1.273.216.075.435.141.655.2.504.132 1.022.254 1.555.355H80V44H36v-8h44a8.21 8.21 0 0 1 8 8v48a4 4 0 0 1-4 4zM48.074 58.492a7.937 7.937 0 0 0-6.135 2.89 7.824 7.824 0 0 0-.775 8.872l6.838 11.886.025.043.016-.027 6.908-11.898a7.825 7.825 0 0 0-.736-8.875 7.95 7.95 0 0 0-6.14-2.891z"
  }));
};

var _extends$3 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties$2(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

var GenericIcon = function GenericIcon(_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$2(_ref, ["styles"]);

  return React.createElement("svg", _extends$3({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), React.createElement("path", {
    d: "M7.932 9c-.305 0-.552.223-.552.5v3c0 .276.247.5.552.5.305 0 .553-.224.553-.5v-3c0-.277-.248-.5-.553-.5zm6.078 5c0 .552-.495 1-1.105 1H2.96c-.61 0-1.105-.448-1.105-1V8c0-.552.494-1 1.105-1h9.945c.61 0 1.105.448 1.105 1v6zM4.065 4.5c0-1.933 1.732-3.5 3.867-3.5C10.068 1 11.8 2.567 11.8 4.5V6H4.065V4.5zm8.84 1.5V4.5c0-2.485-2.226-4.5-4.973-4.5C5.186 0 2.96 2.015 2.96 4.5V6C1.74 6 .75 6.895.75 8v6c0 1.104.99 2 2.21 2h9.945c1.22 0 2.21-.896 2.21-2V8c0-1.105-.99-2-2.21-2z"
  }));
};

var getThemeIcon = function getThemeIcon(vmIcon, generalIcon) {
  return function (themeName) {
    return themeName === 'vm' ? vmIcon : generalIcon;
  };
};

var getLockOutlineLarge = getThemeIcon(VMIcon, GenericIcon);
var componentPaths = [{
  name: "ActionAnchor",
  path: "actions/anchors/ActionAnchor",
  styleguidePath: "Actions/Anchors/ActionAnchor",
  importPath: "web-ui-components/lib/actions/anchors"
}, {
  name: "ActionButton",
  path: "actions/buttons/ActionButton",
  styleguidePath: "Actions/Buttons/ActionButton",
  importPath: "web-ui-components/lib/actions/buttons"
}, {
  name: "EmailLink",
  path: "actions/links/EmailLink",
  styleguidePath: "Actions/Links/EmailLink",
  importPath: "web-ui-components/lib/actions/links"
}, {
  name: "PhoneLink",
  path: "actions/links/PhoneLink",
  styleguidePath: "Actions/Links/PhoneLink",
  importPath: "web-ui-components/lib/actions/links"
}, {
  name: "WebsiteLink",
  path: "actions/links/WebsiteLink",
  styleguidePath: "Actions/Links/WebsiteLink",
  importPath: "web-ui-components/lib/actions/links"
}, {
  name: "InputRadio",
  path: "actions/radios/InputRadio",
  styleguidePath: "Actions/Radios/InputRadio",
  importPath: "web-ui-components/lib/actions/radios"
}, {
  name: "InputRadioGroup",
  path: "actions/radios/InputRadioGroup",
  styleguidePath: "Actions/Radios/InputRadioGroup",
  importPath: "web-ui-components/lib/actions/radios"
}, {
  name: "TallRadioCard",
  path: "actions/radios/TallRadioCard",
  styleguidePath: "Actions/Radios/TallRadioCard",
  importPath: "web-ui-components/lib/actions/radios"
}, {
  name: "WideRadioCard",
  path: "actions/radios/WideRadioCard",
  styleguidePath: "Actions/Radios/WideRadioCard",
  importPath: "web-ui-components/lib/actions/radios"
}, {
  name: "NewWindowAction",
  path: "advisor/actions/NewWindowAction",
  styleguidePath: "Advisor/Actions/NewWindowAction",
  importPath: "web-ui-components/lib/advisor/actions"
}, {
  name: "CustomerAlert",
  path: "advisor/alerts/CustomerAlert",
  styleguidePath: "Advisor/Alerts/CustomerAlert",
  importPath: "web-ui-components/lib/advisor/alerts"
}, {
  name: "DashboardGrid",
  path: "advisor/layout/DashboardGrid",
  styleguidePath: "Advisor/Layout/DashboardGrid",
  importPath: "web-ui-components/lib/advisor/layout"
}, {
  name: "WideModal",
  path: "advisor/layout/WideModal",
  styleguidePath: "Advisor/Layout/WideModal",
  importPath: "web-ui-components/lib/advisor/layout"
}, {
  name: "WindowFrame",
  path: "advisor/layout/WindowFrame",
  styleguidePath: "Advisor/Layout/WindowFrame",
  importPath: "web-ui-components/lib/advisor/layout"
}, {
  name: "ProductRadioCard",
  path: "advisor/radios/ProductRadioCard",
  styleguidePath: "Advisor/Radios/ProductRadioCard",
  importPath: "web-ui-components/lib/advisor/radios"
}, {
  name: "AccountSelect",
  path: "advisor/selects/AccountSelect",
  styleguidePath: "Advisor/Selects/AccountSelect",
  importPath: "web-ui-components/lib/advisor/selects"
}, {
  name: "Anchor",
  path: "atoms/buttons/Anchor",
  styleguidePath: "Atoms/Buttons/Anchor",
  importPath: "web-ui-components/lib/atoms/buttons"
}, {
  name: "Button",
  path: "atoms/buttons/Button",
  styleguidePath: "Atoms/Buttons/Button",
  importPath: "web-ui-components/lib/atoms/buttons"
}, {
  name: "ButtonTitle",
  path: "atoms/buttons/ButtonTitle",
  styleguidePath: "Atoms/Buttons/ButtonTitle",
  importPath: "web-ui-components/lib/atoms/buttons"
}, {
  name: "Calendar",
  path: "atoms/forms/Calendar",
  styleguidePath: "Atoms/Forms/Calendar",
  importPath: "web-ui-components/lib/atoms/forms"
}, {
  name: "Checkbox",
  path: "atoms/forms/Checkbox",
  styleguidePath: "Atoms/Forms/Checkbox",
  importPath: "web-ui-components/lib/atoms/forms"
}, {
  name: "CheckboxToggle",
  path: "atoms/forms/CheckboxToggle",
  styleguidePath: "Atoms/Forms/CheckboxToggle",
  importPath: "web-ui-components/lib/atoms/forms"
}, {
  name: "Datepicker",
  path: "atoms/forms/Datepicker",
  styleguidePath: "Atoms/Forms/Datepicker",
  importPath: "web-ui-components/lib/atoms/forms"
}, {
  name: "FieldDescription",
  path: "atoms/forms/FieldDescription",
  styleguidePath: "Atoms/Forms/FieldDescription",
  importPath: "web-ui-components/lib/atoms/forms"
}, {
  name: "Input",
  path: "atoms/forms/Input/Input",
  styleguidePath: "Atoms/Forms/Input/Input",
  importPath: "web-ui-components/lib/atoms/forms/input"
}, {
  name: "Prefix",
  path: "atoms/forms/Input/Prefix",
  styleguidePath: "Atoms/Forms/Input/Prefix",
  importPath: "web-ui-components/lib/atoms/forms/input"
}, {
  name: "Suffix",
  path: "atoms/forms/Input/Suffix",
  styleguidePath: "Atoms/Forms/Input/Suffix",
  importPath: "web-ui-components/lib/atoms/forms/input"
}, {
  name: "TextPrompt",
  path: "atoms/forms/Input/TextPrompt",
  styleguidePath: "Atoms/Forms/Input/TextPrompt",
  importPath: "web-ui-components/lib/atoms/forms/input"
}, {
  name: "InputClickable",
  path: "atoms/forms/InputClickable",
  styleguidePath: "Atoms/Forms/InputClickable",
  importPath: "web-ui-components/lib/atoms/forms"
}, {
  name: "InputRange",
  path: "atoms/forms/InputRange",
  styleguidePath: "Atoms/Forms/InputRange",
  importPath: "web-ui-components/lib/atoms/forms"
}, {
  name: "LabelTitle",
  path: "atoms/forms/Label/LabelTitle",
  styleguidePath: "Atoms/Forms/Label/LabelTitle",
  importPath: "web-ui-components/lib/atoms/forms/label"
}, {
  name: "Label",
  path: "atoms/forms/Label",
  styleguidePath: "Atoms/Forms/Label",
  importPath: "web-ui-components/lib/atoms/forms"
}, {
  name: "MediaCheckbox",
  path: "atoms/forms/MediaCheckbox",
  styleguidePath: "Atoms/Forms/MediaCheckbox",
  importPath: "web-ui-components/lib/atoms/forms"
}, {
  name: "MediaRadio",
  path: "atoms/forms/MediaRadio",
  styleguidePath: "Atoms/Forms/MediaRadio",
  importPath: "web-ui-components/lib/atoms/forms"
}, {
  name: "MultiSelect",
  path: "atoms/forms/MultiSelect",
  styleguidePath: "Atoms/Forms/MultiSelect",
  importPath: "web-ui-components/lib/atoms/forms"
}, {
  name: "Radio",
  path: "atoms/forms/Radio",
  styleguidePath: "Atoms/Forms/Radio",
  importPath: "web-ui-components/lib/atoms/forms"
}, {
  name: "RadioCard",
  path: "atoms/forms/RadioCard",
  styleguidePath: "Atoms/Forms/RadioCard",
  importPath: "web-ui-components/lib/atoms/forms"
}, {
  name: "Select",
  path: "atoms/forms/Select",
  styleguidePath: "Atoms/Forms/Select",
  importPath: "web-ui-components/lib/atoms/forms"
}, {
  name: "Textarea",
  path: "atoms/forms/Textarea",
  styleguidePath: "Atoms/Forms/Textarea",
  importPath: "web-ui-components/lib/atoms/forms"
}, {
  name: "TextAreaCharacterCount",
  path: "atoms/forms/TextAreaCharacterCount",
  styleguidePath: "Atoms/Forms/TextAreaCharacterCount",
  importPath: "web-ui-components/lib/atoms/forms"
}, {
  name: "TimeEstimationIcon",
  path: "atoms/forms/TimeEstimationIcon",
  styleguidePath: "Atoms/Forms/TimeEstimationIcon",
  importPath: "web-ui-components/lib/atoms/forms"
}, {
  name: "AnimatedIcon",
  path: "atoms/iconography/AnimatedIcon",
  styleguidePath: "Atoms/Iconography/AnimatedIcon",
  importPath: "web-ui-components/lib/atoms/iconography"
}, {
  name: "DistinctiveGeneratedSymbol",
  path: "atoms/iconography/DistinctiveGeneratedSymbol",
  styleguidePath: "Atoms/Iconography/DistinctiveGeneratedSymbol",
  importPath: "web-ui-components/lib/atoms/iconography"
}, {
  name: "Icon",
  path: "atoms/iconography/Icon",
  styleguidePath: "Atoms/Iconography/Icon",
  importPath: "web-ui-components/lib/atoms/iconography"
}, {
  name: "Divider",
  path: "atoms/layout/Divider",
  styleguidePath: "Atoms/Layout/Divider",
  importPath: "web-ui-components/lib/atoms/layout"
}, {
  name: "UploadPreviewContainer",
  path: "atoms/layout/UploadPreviewContainer",
  styleguidePath: "Atoms/Layout/UploadPreviewContainer",
  importPath: "web-ui-components/lib/atoms/layout"
}, {
  name: "AndroidStoreLogo",
  path: "atoms/logo/AndroidStoreLogo",
  styleguidePath: "Atoms/Logo/AndroidStoreLogo",
  importPath: "web-ui-components/lib/atoms/logo"
}, {
  name: "AppleStoreLogo",
  path: "atoms/logo/AppleStoreLogo",
  styleguidePath: "Atoms/Logo/AppleStoreLogo",
  importPath: "web-ui-components/lib/atoms/logo"
}, {
  name: "BankHeader",
  path: "atoms/logo/BankHeader",
  styleguidePath: "Atoms/Logo/BankHeader",
  importPath: "web-ui-components/lib/atoms/logo"
}, {
  name: "BLogo",
  path: "atoms/logo/BLogo",
  styleguidePath: "Atoms/Logo/BLogo",
  importPath: "web-ui-components/lib/atoms/logo"
}, {
  name: "BLogoCircular",
  path: "atoms/logo/BLogoCircular",
  styleguidePath: "Atoms/Logo/BLogoCircular",
  importPath: "web-ui-components/lib/atoms/logo"
}, {
  name: "CBLogo",
  path: "atoms/logo/CBLogo",
  styleguidePath: "Atoms/Logo/CBLogo",
  importPath: "web-ui-components/lib/atoms/logo"
}, {
  name: "CBLogoCircular",
  path: "atoms/logo/CBLogoCircular",
  styleguidePath: "Atoms/Logo/CBLogoCircular",
  importPath: "web-ui-components/lib/atoms/logo"
}, {
  name: "Header",
  path: "atoms/logo/Header",
  styleguidePath: "Atoms/Logo/Header",
  importPath: "web-ui-components/lib/atoms/logo"
}, {
  name: "SwitchGuaranteeLogo",
  path: "atoms/logo/SwitchGuaranteeLogo",
  styleguidePath: "Atoms/Logo/SwitchGuaranteeLogo",
  importPath: "web-ui-components/lib/atoms/logo"
}, {
  name: "VMSecondaryRedLogo",
  path: "atoms/logo/VMSecondaryRedLogo",
  styleguidePath: "Atoms/Logo/VMSecondaryRedLogo",
  importPath: "web-ui-components/lib/atoms/logo"
}, {
  name: "YBLogo",
  path: "atoms/logo/YBLogo",
  styleguidePath: "Atoms/Logo/YBLogo",
  importPath: "web-ui-components/lib/atoms/logo"
}, {
  name: "YBLogoCircular",
  path: "atoms/logo/YBLogoCircular",
  styleguidePath: "Atoms/Logo/YBLogoCircular",
  importPath: "web-ui-components/lib/atoms/logo"
}, {
  name: "Popover",
  path: "atoms/popovers/Popover",
  styleguidePath: "Atoms/Popovers/Popover",
  importPath: "web-ui-components/lib/atoms/popovers"
}, {
  name: "IdentityProcessingSignal",
  path: "atoms/signals/IdentityProcessingSignal",
  styleguidePath: "Atoms/Signals/IdentityProcessingSignal",
  importPath: "web-ui-components/lib/atoms/signals"
}, {
  name: "UploadProcessingSignal",
  path: "atoms/signals/UploadProcessingSignal",
  styleguidePath: "Atoms/Signals/UploadProcessingSignal",
  importPath: "web-ui-components/lib/atoms/signals"
}, {
  name: "BadgeLabel",
  path: "atoms/text/BadgeLabel",
  styleguidePath: "Atoms/Text/BadgeLabel",
  importPath: "web-ui-components/lib/atoms/text"
}, {
  name: "BulletedList",
  path: "atoms/text/BulletedList",
  styleguidePath: "Atoms/Text/BulletedList",
  importPath: "web-ui-components/lib/atoms/text"
}, {
  name: "Callout",
  path: "atoms/text/Callout",
  styleguidePath: "Atoms/Text/Callout",
  importPath: "web-ui-components/lib/atoms/text"
}, {
  name: "List",
  path: "atoms/text/List",
  styleguidePath: "Atoms/Text/List",
  importPath: "web-ui-components/lib/atoms/text"
}, {
  name: "NumberedList",
  path: "atoms/text/NumberedList",
  styleguidePath: "Atoms/Text/NumberedList",
  importPath: "web-ui-components/lib/atoms/text"
}, {
  name: "StatusBadge",
  path: "atoms/text/StatusBadge",
  styleguidePath: "Atoms/Text/StatusBadge",
  importPath: "web-ui-components/lib/atoms/text"
}, {
  name: "TextBody",
  path: "atoms/text/TextBody",
  styleguidePath: "Atoms/Text/TextBody",
  importPath: "web-ui-components/lib/atoms/text"
}, {
  name: "TextStyled",
  path: "atoms/text/TextStyled",
  styleguidePath: "Atoms/Text/TextStyled",
  importPath: "web-ui-components/lib/atoms/text"
}, {
  name: "TheSmallPrint",
  path: "atoms/text/TheSmallPrint",
  styleguidePath: "Atoms/Text/TheSmallPrint",
  importPath: "web-ui-components/lib/atoms/text"
}, {
  name: "Title",
  path: "atoms/text/Title",
  styleguidePath: "Atoms/Text/Title",
  importPath: "web-ui-components/lib/atoms/text"
}, {
  name: "TransitionBlock",
  path: "atoms/transitions/TransitionBlock",
  styleguidePath: "Atoms/Transitions/TransitionBlock",
  importPath: "web-ui-components/lib/atoms/transitions"
}, {
  name: "EmailInput",
  path: "communication/email/text-inputs/EmailInput",
  styleguidePath: "Communication/Email/Text-inputs/EmailInput",
  importPath: "web-ui-components/lib/communication/email/text-inputs"
}, {
  name: "Mail",
  path: "communication/messaging/Mail",
  styleguidePath: "Communication/Messaging/Mail",
  importPath: "web-ui-components/lib/communication/messaging"
}, {
  name: "Webchat",
  path: "communication/support/Webchat",
  styleguidePath: "Communication/Support/Webchat",
  importPath: "web-ui-components/lib/communication/support"
}, {
  name: "GenericCheckbox",
  path: "data/capture/checkboxes/GenericCheckbox",
  styleguidePath: "Data/Capture/Checkboxes/GenericCheckbox",
  importPath: "web-ui-components/lib/data/capture/checkboxes"
}, {
  name: "StandaloneCheckbox",
  path: "data/capture/checkboxes/StandaloneCheckbox",
  styleguidePath: "Data/Capture/Checkboxes/StandaloneCheckbox",
  importPath: "web-ui-components/lib/data/capture/checkboxes"
}, {
  name: "AccountNumberInput",
  path: "data/capture/inputs/AccountNumberInput",
  styleguidePath: "Data/Capture/Inputs/AccountNumberInput",
  importPath: "web-ui-components/lib/data/capture/inputs"
}, {
  name: "DateOfBirthInput",
  path: "data/capture/inputs/DateOfBirthInput",
  styleguidePath: "Data/Capture/Inputs/DateOfBirthInput",
  importPath: "web-ui-components/lib/data/capture/inputs"
}, {
  name: "GenericAlphaNumericInput",
  path: "data/capture/inputs/GenericAlphaNumericInput",
  styleguidePath: "Data/Capture/Inputs/GenericAlphaNumericInput",
  importPath: "web-ui-components/lib/data/capture/inputs"
}, {
  name: "GenericTextInput",
  path: "data/capture/inputs/GenericTextInput",
  styleguidePath: "Data/Capture/Inputs/GenericTextInput",
  importPath: "web-ui-components/lib/data/capture/inputs"
}, {
  name: "LandlineNumberInput",
  path: "data/capture/inputs/LandlineNumberInput",
  styleguidePath: "Data/Capture/Inputs/LandlineNumberInput",
  importPath: "web-ui-components/lib/data/capture/inputs"
}, {
  name: "MoneyInput",
  path: "data/capture/inputs/MoneyInput",
  styleguidePath: "Data/Capture/Inputs/MoneyInput",
  importPath: "web-ui-components/lib/data/capture/inputs"
}, {
  name: "MonthAndYearDateInput",
  path: "data/capture/inputs/MonthAndYearDateInput",
  styleguidePath: "Data/Capture/Inputs/MonthAndYearDateInput",
  importPath: "web-ui-components/lib/data/capture/inputs"
}, {
  name: "SortcodeInput",
  path: "data/capture/inputs/SortcodeInput",
  styleguidePath: "Data/Capture/Inputs/SortcodeInput",
  importPath: "web-ui-components/lib/data/capture/inputs"
}, {
  name: "UKOnlyMobileNumberInput",
  path: "data/capture/inputs/UKOnlyMobileNumberInput",
  styleguidePath: "Data/Capture/Inputs/UKOnlyMobileNumberInput",
  importPath: "web-ui-components/lib/data/capture/inputs"
}, {
  name: "UKOnlyPostcodeInput",
  path: "data/capture/inputs/UKOnlyPostcodeInput",
  styleguidePath: "Data/Capture/Inputs/UKOnlyPostcodeInput",
  importPath: "web-ui-components/lib/data/capture/inputs"
}, {
  name: "WorldwideMobileNumberInput",
  path: "data/capture/inputs/WorldwideMobileNumberInput",
  styleguidePath: "Data/Capture/Inputs/WorldwideMobileNumberInput",
  importPath: "web-ui-components/lib/data/capture/inputs"
}, {
  name: "YearsAndMonthsCountInput",
  path: "data/capture/inputs/YearsAndMonthsCountInput",
  styleguidePath: "Data/Capture/Inputs/YearsAndMonthsCountInput",
  importPath: "web-ui-components/lib/data/capture/inputs"
}, {
  name: "DayOfMonthPicker",
  path: "data/capture/pickers/DayOfMonthPicker",
  styleguidePath: "Data/Capture/Pickers/DayOfMonthPicker",
  importPath: "web-ui-components/lib/data/capture/pickers"
}, {
  name: "FileProgressTakeover",
  path: "data/capture/progress/FileProgressTakeover",
  styleguidePath: "Data/Capture/Progress/FileProgressTakeover",
  importPath: "web-ui-components/lib/data/capture/progress"
}, {
  name: "GenericRadio",
  path: "data/capture/radios/GenericRadio",
  styleguidePath: "Data/Capture/Radios/GenericRadio",
  importPath: "web-ui-components/lib/data/capture/radios"
}, {
  name: "GenericSelect",
  path: "data/capture/selects/GenericSelect",
  styleguidePath: "Data/Capture/Selects/GenericSelect",
  importPath: "web-ui-components/lib/data/capture/selects"
}, {
  name: "GenericTextArea",
  path: "data/capture/text-areas/GenericTextArea",
  styleguidePath: "Data/Capture/Text-areas/GenericTextArea",
  importPath: "web-ui-components/lib/data/capture/text-areas"
}, {
  name: "GenericPaginator",
  path: "data/filter-and-search/paginators/GenericPaginator",
  styleguidePath: "Data/Filter-and-search/Paginators/GenericPaginator",
  importPath: "web-ui-components/lib/data/filter-and-search/paginators"
}, {
  name: "SearchTextInput",
  path: "data/filter-and-search/text-inputs/SearchTextInput",
  styleguidePath: "Data/Filter-and-search/Text-inputs/SearchTextInput",
  importPath: "web-ui-components/lib/data/filter-and-search/text-inputs"
}, {
  name: "GenericDescriptionList",
  path: "data/lists/description-lists/GenericDescriptionList",
  styleguidePath: "Data/Lists/Description-lists/GenericDescriptionList",
  importPath: "web-ui-components/lib/data/lists/description-lists"
}, {
  name: "NoResultsTile",
  path: "data/results/tiles/NoResultsTile",
  styleguidePath: "Data/Results/Tiles/NoResultsTile",
  importPath: "web-ui-components/lib/data/results/tiles"
}, {
  name: "DocumentLink",
  path: "documents/navigation/links/DocumentLink",
  styleguidePath: "Documents/Navigation/Links/DocumentLink",
  importPath: "web-ui-components/lib/documents/navigation/links"
}, {
  name: "DocumentLinkPlate",
  path: "documents/navigation/plates/DocumentLinkPlate",
  styleguidePath: "Documents/Navigation/Plates/DocumentLinkPlate",
  importPath: "web-ui-components/lib/documents/navigation/plates"
}, {
  name: "PrintButton",
  path: "documents/printing/buttons/PrintButton",
  styleguidePath: "Documents/Printing/Buttons/PrintButton",
  importPath: "web-ui-components/lib/documents/printing/buttons"
}, {
  name: "DocumentStatusBandCardAction",
  path: "documents/statuses/cards/DocumentStatusBandCard/DocumentStatusBandCardAction",
  styleguidePath: "Documents/Statuses/Cards/DocumentStatusBandCard/DocumentStatusBandCardAction",
  importPath: "web-ui-components/lib/documents/statuses/cards/documentStatusBandCard"
}, {
  name: "DocumentStatusBandCard",
  path: "documents/statuses/cards/DocumentStatusBandCard",
  styleguidePath: "Documents/Statuses/Cards/DocumentStatusBandCard",
  importPath: "web-ui-components/lib/documents/statuses/cards"
}, {
  name: "FileInput",
  path: "documents/upload/FileInput",
  styleguidePath: "Documents/Upload/FileInput",
  importPath: "web-ui-components/lib/documents/upload"
}, {
  name: "AccountCheckboxCard",
  path: "finance/accounts/cards/AccountCheckboxCard",
  styleguidePath: "Finance/Accounts/Cards/AccountCheckboxCard",
  importPath: "web-ui-components/lib/finance/accounts/cards"
}, {
  name: "AccountLegacyUpdateCard",
  path: "finance/accounts/cards/AccountLegacyUpdateCard",
  styleguidePath: "Finance/Accounts/Cards/AccountLegacyUpdateCard",
  importPath: "web-ui-components/lib/finance/accounts/cards"
}, {
  name: "AccountLinkCard",
  path: "finance/accounts/cards/AccountLinkCard",
  styleguidePath: "Finance/Accounts/Cards/AccountLinkCard",
  importPath: "web-ui-components/lib/finance/accounts/cards"
}, {
  name: "AccountPoolCard",
  path: "finance/accounts/cards/AccountPoolCard",
  styleguidePath: "Finance/Accounts/Cards/AccountPoolCard",
  importPath: "web-ui-components/lib/finance/accounts/cards"
}, {
  name: "AccountSelectCard",
  path: "finance/accounts/cards/AccountSelectCard",
  styleguidePath: "Finance/Accounts/Cards/AccountSelectCard",
  importPath: "web-ui-components/lib/finance/accounts/cards"
}, {
  name: "AccountAuthorisationPanel",
  path: "finance/accounts/panels/AccountAuthorisationPanel",
  styleguidePath: "Finance/Accounts/Panels/AccountAuthorisationPanel",
  importPath: "web-ui-components/lib/finance/accounts/panels"
}, {
  name: "AccountBalancesSelectPanel",
  path: "finance/accounts/panels/AccountBalancesSelectPanel",
  styleguidePath: "Finance/Accounts/Panels/AccountBalancesSelectPanel",
  importPath: "web-ui-components/lib/finance/accounts/panels"
}, {
  name: "AccountLegacyPanel",
  path: "finance/accounts/panels/AccountLegacyPanel",
  styleguidePath: "Finance/Accounts/Panels/AccountLegacyPanel",
  importPath: "web-ui-components/lib/finance/accounts/panels"
}, {
  name: "AccountPoolTablePanel",
  path: "finance/accounts/panels/AccountPoolTablePanel",
  styleguidePath: "Finance/Accounts/Panels/AccountPoolTablePanel",
  importPath: "web-ui-components/lib/finance/accounts/panels"
}, {
  name: "AccountRadioCard",
  path: "finance/accounts/radios/AccountRadioCard",
  styleguidePath: "Finance/Accounts/Radios/AccountRadioCard",
  importPath: "web-ui-components/lib/finance/accounts/radios"
}, {
  name: "AccountPaymentReviewTable",
  path: "finance/accounts/tables/AccountPaymentReviewTable",
  styleguidePath: "Finance/Accounts/Tables/AccountPaymentReviewTable",
  importPath: "web-ui-components/lib/finance/accounts/tables"
}, {
  name: "AccountPaymentSubmittedTable",
  path: "finance/accounts/tables/AccountPaymentSubmittedTable",
  styleguidePath: "Finance/Accounts/Tables/AccountPaymentSubmittedTable",
  importPath: "web-ui-components/lib/finance/accounts/tables"
}, {
  name: "AccountPaymentTable",
  path: "finance/accounts/tables/AccountPaymentTable",
  styleguidePath: "Finance/Accounts/Tables/AccountPaymentTable",
  importPath: "web-ui-components/lib/finance/accounts/tables"
}, {
  name: "AccountSummaryTile",
  path: "finance/accounts/tiles/AccountSummaryTile",
  styleguidePath: "Finance/Accounts/Tiles/AccountSummaryTile",
  importPath: "web-ui-components/lib/finance/accounts/tiles"
}, {
  name: "CurrencySelect",
  path: "finance/currency/selects/CurrencySelect",
  styleguidePath: "Finance/Currency/Selects/CurrencySelect",
  importPath: "web-ui-components/lib/finance/currency/selects"
}, {
  name: "FormInput",
  path: "forms/FormInput",
  styleguidePath: "Forms/FormInput",
  importPath: "web-ui-components/lib/forms"
}, {
  name: "BlockField",
  path: "global/layout/BlockField",
  styleguidePath: "Global/Layout/BlockField",
  importPath: "web-ui-components/lib/global/layout"
}, {
  name: "BlockFieldColumn",
  path: "global/layout/BlockFieldColumn",
  styleguidePath: "Global/Layout/BlockFieldColumn",
  importPath: "web-ui-components/lib/global/layout"
}, {
  name: "CenterImageContainer",
  path: "global/layout/CenterImageContainer",
  styleguidePath: "Global/Layout/CenterImageContainer",
  importPath: "web-ui-components/lib/global/layout"
}, {
  name: "Column",
  path: "global/layout/Column",
  styleguidePath: "Global/Layout/Column",
  importPath: "web-ui-components/lib/global/layout"
}, {
  name: "Container",
  path: "global/layout/Container",
  styleguidePath: "Global/Layout/Container",
  importPath: "web-ui-components/lib/global/layout"
}, {
  name: "FlexColumn",
  path: "global/layout/FlexColumn",
  styleguidePath: "Global/Layout/FlexColumn",
  importPath: "web-ui-components/lib/global/layout"
}, {
  name: "FlexRow",
  path: "global/layout/FlexRow",
  styleguidePath: "Global/Layout/FlexRow",
  importPath: "web-ui-components/lib/global/layout"
}, {
  name: "Frame",
  path: "global/layout/Frame",
  styleguidePath: "Global/Layout/Frame",
  importPath: "web-ui-components/lib/global/layout"
}, {
  name: "InternalSlot",
  path: "global/layout/InternalSlot",
  styleguidePath: "Global/Layout/InternalSlot",
  importPath: "web-ui-components/lib/global/layout"
}, {
  name: "LeftAndRightAlignment",
  path: "global/layout/LeftAndRightAlignment",
  styleguidePath: "Global/Layout/LeftAndRightAlignment",
  importPath: "web-ui-components/lib/global/layout"
}, {
  name: "PageLayout",
  path: "global/layout/PageLayout",
  styleguidePath: "Global/Layout/PageLayout",
  importPath: "web-ui-components/lib/global/layout"
}, {
  name: "HeaderSection",
  path: "global/layout/Pages/HeaderSection",
  styleguidePath: "Global/Layout/Pages/HeaderSection",
  importPath: "web-ui-components/lib/global/layout/pages"
}, {
  name: "ServicingSection",
  path: "global/layout/Pages/ServicingSection",
  styleguidePath: "Global/Layout/Pages/ServicingSection",
  importPath: "web-ui-components/lib/global/layout/pages"
}, {
  name: "WorkflowSection",
  path: "global/layout/Pages/WorkflowSection",
  styleguidePath: "Global/Layout/Pages/WorkflowSection",
  importPath: "web-ui-components/lib/global/layout/pages"
}, {
  name: "ResponsiveLayoutPair",
  path: "global/layout/ResponsiveLayoutPair",
  styleguidePath: "Global/Layout/ResponsiveLayoutPair",
  importPath: "web-ui-components/lib/global/layout"
}, {
  name: "Row",
  path: "global/layout/Row",
  styleguidePath: "Global/Layout/Row",
  importPath: "web-ui-components/lib/global/layout"
}, {
  name: "ContentContainer",
  path: "layout/containers/ContentContainer",
  styleguidePath: "Layout/Containers/ContentContainer",
  importPath: "web-ui-components/lib/layout/containers"
}, {
  name: "Main",
  path: "layout/containers/Main",
  styleguidePath: "Layout/Containers/Main",
  importPath: "web-ui-components/lib/layout/containers"
}, {
  name: "GenericAccordion",
  path: "layout/content/accordions/GenericAccordion",
  styleguidePath: "Layout/Content/Accordions/GenericAccordion",
  importPath: "web-ui-components/lib/layout/content/accordions"
}, {
  name: "StatusBanner",
  path: "layout/content/banners/StatusBanner",
  styleguidePath: "Layout/Content/Banners/StatusBanner",
  importPath: "web-ui-components/lib/layout/content/banners"
}, {
  name: "GenericDivider",
  path: "layout/content/breaks/GenericDivider",
  styleguidePath: "Layout/Content/Breaks/GenericDivider",
  importPath: "web-ui-components/lib/layout/content/breaks"
}, {
  name: "MultiButtonModal",
  path: "layout/content/modals/MultiButtonModal",
  styleguidePath: "Layout/Content/Modals/MultiButtonModal",
  importPath: "web-ui-components/lib/layout/content/modals"
}, {
  name: "BrandedPanelHeader",
  path: "layout/content/panels/BrandedPanel/BrandedPanelHeader",
  styleguidePath: "Layout/Content/Panels/BrandedPanel/BrandedPanelHeader",
  importPath: "web-ui-components/lib/layout/content/panels/brandedPanel"
}, {
  name: "BrandedPanel",
  path: "layout/content/panels/BrandedPanel",
  styleguidePath: "Layout/Content/Panels/BrandedPanel",
  importPath: "web-ui-components/lib/layout/content/panels"
}, {
  name: "ConditionalPanel",
  path: "layout/content/panels/ConditionalPanel",
  styleguidePath: "Layout/Content/Panels/ConditionalPanel",
  importPath: "web-ui-components/lib/layout/content/panels"
}, {
  name: "ContentRevealPanel",
  path: "layout/content/panels/ContentRevealPanel",
  styleguidePath: "Layout/Content/Panels/ContentRevealPanel",
  importPath: "web-ui-components/lib/layout/content/panels"
}, {
  name: "InformationRevealPanel",
  path: "layout/content/panels/InformationRevealPanel",
  styleguidePath: "Layout/Content/Panels/InformationRevealPanel",
  importPath: "web-ui-components/lib/layout/content/panels"
}, {
  name: "SimplePanel",
  path: "layout/content/panels/SimplePanel",
  styleguidePath: "Layout/Content/Panels/SimplePanel",
  importPath: "web-ui-components/lib/layout/content/panels"
}, {
  name: "StatusPanel",
  path: "layout/content/panels/StatusPanel",
  styleguidePath: "Layout/Content/Panels/StatusPanel",
  importPath: "web-ui-components/lib/layout/content/panels"
}, {
  name: "ToggleButtonPanel",
  path: "layout/content/panels/ToggleButtonPanel",
  styleguidePath: "Layout/Content/Panels/ToggleButtonPanel",
  importPath: "web-ui-components/lib/layout/content/panels"
}, {
  name: "AttentionTile",
  path: "layout/content/tiles/AttentionTile",
  styleguidePath: "Layout/Content/Tiles/AttentionTile",
  importPath: "web-ui-components/lib/layout/content/tiles"
}, {
  name: "GuidanceTile",
  path: "layout/content/tiles/GuidanceTile",
  styleguidePath: "Layout/Content/Tiles/GuidanceTile",
  importPath: "web-ui-components/lib/layout/content/tiles"
}, {
  name: "OutcomeTile",
  path: "layout/content/tiles/OutcomeTile",
  styleguidePath: "Layout/Content/Tiles/OutcomeTile",
  importPath: "web-ui-components/lib/layout/content/tiles"
}, {
  name: "RecapTile",
  path: "layout/content/tiles/RecapTile",
  styleguidePath: "Layout/Content/Tiles/RecapTile",
  importPath: "web-ui-components/lib/layout/content/tiles"
}, {
  name: "StandoutTile",
  path: "layout/content/tiles/StandoutTile",
  styleguidePath: "Layout/Content/Tiles/StandoutTile",
  importPath: "web-ui-components/lib/layout/content/tiles"
}, {
  name: "ValidationMessageTile",
  path: "layout/content/tiles/ValidationMessageTile",
  styleguidePath: "Layout/Content/Tiles/ValidationMessageTile",
  importPath: "web-ui-components/lib/layout/content/tiles"
}, {
  name: "GridViewToggle",
  path: "layout/content/views/GridViewToggle",
  styleguidePath: "Layout/Content/Views/GridViewToggle",
  importPath: "web-ui-components/lib/layout/content/views"
}, {
  name: "GenericFieldWrapper",
  path: "layout/fieldWrappers/GenericFieldWrapper",
  styleguidePath: "Layout/FieldWrappers/GenericFieldWrapper",
  importPath: "web-ui-components/lib/layout/fieldWrappers"
}, {
  name: "MainFixedFooter",
  path: "layout/footers/MainFixedFooter",
  styleguidePath: "Layout/Footers/MainFixedFooter",
  importPath: "web-ui-components/lib/layout/footers"
}, {
  name: "Grid",
  path: "layout/grids/Grid",
  styleguidePath: "Layout/Grids/Grid",
  importPath: "web-ui-components/lib/layout/grids"
}, {
  name: "Inline",
  path: "layout/grids/Inline",
  styleguidePath: "Layout/Grids/Inline",
  importPath: "web-ui-components/lib/layout/grids"
}, {
  name: "ContainedHeader",
  path: "layout/headers/ContainedHeader",
  styleguidePath: "Layout/Headers/ContainedHeader",
  importPath: "web-ui-components/lib/layout/headers"
}, {
  name: "FixedFooter",
  path: "layout/sections/footers/FixedFooter",
  styleguidePath: "Layout/Sections/Footers/FixedFooter",
  importPath: "web-ui-components/lib/layout/sections/footers"
}, {
  name: "ApplicationFormShell",
  path: "layout/shells/ApplicationFormShell",
  styleguidePath: "Layout/Shells/ApplicationFormShell",
  importPath: "web-ui-components/lib/layout/shells"
}, {
  name: "DataManagementShell",
  path: "layout/shells/DataManagementShell",
  styleguidePath: "Layout/Shells/DataManagementShell",
  importPath: "web-ui-components/lib/layout/shells"
}, {
  name: "ShellInnerSpacer",
  path: "layout/shells/ShellInnerSpacer",
  styleguidePath: "Layout/Shells/ShellInnerSpacer",
  importPath: "web-ui-components/lib/layout/shells"
}, {
  name: "VerticalReviewTable",
  path: "layout/tables/VerticalReviewTable",
  styleguidePath: "Layout/Tables/VerticalReviewTable",
  importPath: "web-ui-components/lib/layout/tables"
}, {
  name: "NonUKAddressFieldset",
  path: "location/addresses/fieldsets/NonUKAddressFieldset",
  styleguidePath: "Location/Addresses/Fieldsets/NonUKAddressFieldset",
  importPath: "web-ui-components/lib/location/addresses/fieldsets"
}, {
  name: "UKAddressFieldset",
  path: "location/addresses/fieldsets/UKAddressFieldset",
  styleguidePath: "Location/Addresses/Fieldsets/UKAddressFieldset",
  importPath: "web-ui-components/lib/location/addresses/fieldsets"
}, {
  name: "UKAddressCaptureModule",
  path: "location/addresses/modules/UKAddressCaptureModule",
  styleguidePath: "Location/Addresses/Modules/UKAddressCaptureModule",
  importPath: "web-ui-components/lib/location/addresses/modules"
}, {
  name: "UKAddressCaptureModule2",
  path: "location/addresses/modules/UKAddressCaptureModule2",
  styleguidePath: "Location/Addresses/Modules/UKAddressCaptureModule2",
  importPath: "web-ui-components/lib/location/addresses/modules"
}, {
  name: "BaseSelect",
  path: "location/places/selects/BaseSelect",
  styleguidePath: "Location/Places/Selects/BaseSelect",
  importPath: "web-ui-components/lib/location/places/selects"
}, {
  name: "CountrySelect",
  path: "location/places/selects/CountrySelect",
  styleguidePath: "Location/Places/Selects/CountrySelect",
  importPath: "web-ui-components/lib/location/places/selects"
}, {
  name: "UKCitySelect",
  path: "location/places/selects/UKCitySelect",
  styleguidePath: "Location/Places/Selects/UKCitySelect",
  importPath: "web-ui-components/lib/location/places/selects"
}, {
  name: "AccordionItem",
  path: "molecules/accordions/Accordion/AccordionItem",
  styleguidePath: "Molecules/Accordions/Accordion/AccordionItem",
  importPath: "web-ui-components/lib/molecules/accordions/accordion"
}, {
  name: "Accordion",
  path: "molecules/accordions/Accordion",
  styleguidePath: "Molecules/Accordions/Accordion",
  importPath: "web-ui-components/lib/molecules/accordions"
}, {
  name: "AccordionTable",
  path: "molecules/accordions/AccordionTable",
  styleguidePath: "Molecules/Accordions/AccordionTable",
  importPath: "web-ui-components/lib/molecules/accordions"
}, {
  name: "ContentReveal",
  path: "molecules/accordions/ContentReveal",
  styleguidePath: "Molecules/Accordions/ContentReveal",
  importPath: "web-ui-components/lib/molecules/accordions"
}, {
  name: "ExpansionPanel",
  path: "molecules/accordions/ExpansionPanel",
  styleguidePath: "Molecules/Accordions/ExpansionPanel",
  importPath: "web-ui-components/lib/molecules/accordions"
}, {
  name: "ExpansionTable",
  path: "molecules/accordions/ExpansionTable",
  styleguidePath: "Molecules/Accordions/ExpansionTable",
  importPath: "web-ui-components/lib/molecules/accordions"
}, {
  name: "ButtonGroup",
  path: "molecules/buttons/ButtonGroup",
  styleguidePath: "Molecules/Buttons/ButtonGroup",
  importPath: "web-ui-components/lib/molecules/buttons"
}, {
  name: "SortingCardGroup",
  path: "molecules/card-groups/SortingCardGroup",
  styleguidePath: "Molecules/Card-groups/SortingCardGroup",
  importPath: "web-ui-components/lib/molecules/card-groups"
}, {
  name: "AccountCard",
  path: "molecules/cards/AccountCard",
  styleguidePath: "Molecules/Cards/AccountCard",
  importPath: "web-ui-components/lib/molecules/cards"
}, {
  name: "AccountSummaryLinkCard",
  path: "molecules/cards/AccountSummaryLinkCard",
  styleguidePath: "Molecules/Cards/AccountSummaryLinkCard",
  importPath: "web-ui-components/lib/molecules/cards"
}, {
  name: "DateCard",
  path: "molecules/cards/DateCard",
  styleguidePath: "Molecules/Cards/DateCard",
  importPath: "web-ui-components/lib/molecules/cards"
}, {
  name: "PromoCard",
  path: "molecules/cards/PromoCard",
  styleguidePath: "Molecules/Cards/PromoCard",
  importPath: "web-ui-components/lib/molecules/cards"
}, {
  name: "StackingCard",
  path: "molecules/cards/StackingCard",
  styleguidePath: "Molecules/Cards/StackingCard",
  importPath: "web-ui-components/lib/molecules/cards"
}, {
  name: "Autocomplete",
  path: "molecules/forms/Autocomplete",
  styleguidePath: "Molecules/Forms/Autocomplete",
  importPath: "web-ui-components/lib/molecules/forms"
}, {
  name: "ConfirmationCheckbox",
  path: "molecules/forms/ConfirmationCheckbox",
  styleguidePath: "Molecules/Forms/ConfirmationCheckbox",
  importPath: "web-ui-components/lib/molecules/forms"
}, {
  name: "DaySelector",
  path: "molecules/forms/DaySelector",
  styleguidePath: "Molecules/Forms/DaySelector",
  importPath: "web-ui-components/lib/molecules/forms"
}, {
  name: "FieldBody",
  path: "molecules/forms/Field/FieldBody",
  styleguidePath: "Molecules/Forms/Field/FieldBody",
  importPath: "web-ui-components/lib/molecules/forms/field"
}, {
  name: "FieldHeader",
  path: "molecules/forms/Field/FieldHeader",
  styleguidePath: "Molecules/Forms/Field/FieldHeader",
  importPath: "web-ui-components/lib/molecules/forms/field"
}, {
  name: "FormField",
  path: "molecules/forms/Field/FormField",
  styleguidePath: "Molecules/Forms/Field/FormField",
  importPath: "web-ui-components/lib/molecules/forms/field"
}, {
  name: "Field",
  path: "molecules/forms/Field",
  styleguidePath: "Molecules/Forms/Field",
  importPath: "web-ui-components/lib/molecules/forms"
}, {
  name: "PasswordReveal",
  path: "molecules/forms/PasswordReveal",
  styleguidePath: "Molecules/Forms/PasswordReveal",
  importPath: "web-ui-components/lib/molecules/forms"
}, {
  name: "RadioCardGroup",
  path: "molecules/forms/RadioCardGroup",
  styleguidePath: "Molecules/Forms/RadioCardGroup",
  importPath: "web-ui-components/lib/molecules/forms"
}, {
  name: "Search",
  path: "molecules/forms/Search",
  styleguidePath: "Molecules/Forms/Search",
  importPath: "web-ui-components/lib/molecules/forms"
}, {
  name: "SearchForm",
  path: "molecules/forms/SearchForm",
  styleguidePath: "Molecules/Forms/SearchForm",
  importPath: "web-ui-components/lib/molecules/forms"
}, {
  name: "SegmentedControl",
  path: "molecules/forms/SegmentedControl",
  styleguidePath: "Molecules/Forms/SegmentedControl",
  importPath: "web-ui-components/lib/molecules/forms"
}, {
  name: "SegmentedControlItem",
  path: "molecules/forms/SegmentedControl/SegmentedControlItem",
  styleguidePath: "Molecules/Forms/SegmentedControl/SegmentedControlItem",
  importPath: "web-ui-components/lib/molecules/forms/segmentedControl"
}, {
  name: "SegmentedSlider",
  path: "molecules/forms/SegmentedSlider",
  styleguidePath: "Molecules/Forms/SegmentedSlider",
  importPath: "web-ui-components/lib/molecules/forms"
}, {
  name: "TickMarks",
  path: "molecules/forms/SegmentedSlider/TickMarks",
  styleguidePath: "Molecules/Forms/SegmentedSlider/TickMarks",
  importPath: "web-ui-components/lib/molecules/forms/segmentedSlider"
}, {
  name: "ValidationMessage",
  path: "molecules/forms/ValidationMessage",
  styleguidePath: "Molecules/Forms/ValidationMessage",
  importPath: "web-ui-components/lib/molecules/forms"
}, {
  name: "IconTextDynamic",
  path: "molecules/icon-text-dynamic/IconTextDynamic",
  styleguidePath: "Molecules/Icon-text-dynamic/IconTextDynamic",
  importPath: "web-ui-components/lib/molecules/icon-text-dynamic"
}, {
  name: "IconText",
  path: "molecules/icon-text/IconText",
  styleguidePath: "Molecules/Icon-text/IconText",
  importPath: "web-ui-components/lib/molecules/icon-text"
}, {
  name: "BackAnchor",
  path: "molecules/navigation/BackAnchor",
  styleguidePath: "Molecules/Navigation/BackAnchor",
  importPath: "web-ui-components/lib/molecules/navigation"
}, {
  name: "BackButton",
  path: "molecules/navigation/BackButton",
  styleguidePath: "Molecules/Navigation/BackButton",
  importPath: "web-ui-components/lib/molecules/navigation"
}, {
  name: "Utility",
  path: "molecules/navigation/Utility",
  styleguidePath: "Molecules/Navigation/Utility",
  importPath: "web-ui-components/lib/molecules/navigation"
}, {
  name: "Alert",
  path: "molecules/nbas/Alert",
  styleguidePath: "Molecules/Nbas/Alert",
  importPath: "web-ui-components/lib/molecules/nbas"
}, {
  name: "Promo",
  path: "molecules/nbas/Promo",
  styleguidePath: "Molecules/Nbas/Promo",
  importPath: "web-ui-components/lib/molecules/nbas"
}, {
  name: "ContrastingFormPanel",
  path: "molecules/panels/ContrastingFormPanel",
  styleguidePath: "Molecules/Panels/ContrastingFormPanel",
  importPath: "web-ui-components/lib/molecules/panels"
}, {
  name: "DocumentAction",
  path: "molecules/panels/DocumentAction",
  styleguidePath: "Molecules/Panels/DocumentAction",
  importPath: "web-ui-components/lib/molecules/panels"
}, {
  name: "IconifiedBulletPoint",
  path: "molecules/panels/IconifiedBulletPoint",
  styleguidePath: "Molecules/Panels/IconifiedBulletPoint",
  importPath: "web-ui-components/lib/molecules/panels"
}, {
  name: "Panel",
  path: "molecules/panels/Panel",
  styleguidePath: "Molecules/Panels/Panel",
  importPath: "web-ui-components/lib/molecules/panels"
}, {
  name: "PanelBody",
  path: "molecules/panels/Panel/PanelBody",
  styleguidePath: "Molecules/Panels/Panel/PanelBody",
  importPath: "web-ui-components/lib/molecules/panels/panel"
}, {
  name: "PanelFooter",
  path: "molecules/panels/Panel/PanelFooter",
  styleguidePath: "Molecules/Panels/Panel/PanelFooter",
  importPath: "web-ui-components/lib/molecules/panels/panel"
}, {
  name: "PanelHeader",
  path: "molecules/panels/Panel/PanelHeader",
  styleguidePath: "Molecules/Panels/Panel/PanelHeader",
  importPath: "web-ui-components/lib/molecules/panels/panel"
}, {
  name: "PanelSector",
  path: "molecules/panels/Panel/PanelSector",
  styleguidePath: "Molecules/Panels/Panel/PanelSector",
  importPath: "web-ui-components/lib/molecules/panels/panel"
}, {
  name: "SettingLink",
  path: "molecules/panels/SettingLink",
  styleguidePath: "Molecules/Panels/SettingLink",
  importPath: "web-ui-components/lib/molecules/panels"
}, {
  name: "SubordinatePanel",
  path: "molecules/panels/SubordinatePanel",
  styleguidePath: "Molecules/Panels/SubordinatePanel",
  importPath: "web-ui-components/lib/molecules/panels"
}, {
  name: "TogglePanel",
  path: "molecules/panels/TogglePanel",
  styleguidePath: "Molecules/Panels/TogglePanel",
  importPath: "web-ui-components/lib/molecules/panels"
}, {
  name: "PaymentReview",
  path: "molecules/payments/PaymentReview",
  styleguidePath: "Molecules/Payments/PaymentReview",
  importPath: "web-ui-components/lib/molecules/payments"
}, {
  name: "ProgressIndicator",
  path: "molecules/progress/ProgressIndicator",
  styleguidePath: "Molecules/Progress/ProgressIndicator",
  importPath: "web-ui-components/lib/molecules/progress"
}, {
  name: "ProgressIndicatorItem",
  path: "molecules/progress/ProgressIndicator/ProgressIndicatorItem",
  styleguidePath: "Molecules/Progress/ProgressIndicator/ProgressIndicatorItem",
  importPath: "web-ui-components/lib/molecules/progress/progressIndicator"
}, {
  name: "ComparisonTable",
  path: "molecules/tables/ComparisonTable",
  styleguidePath: "Molecules/Tables/ComparisonTable",
  importPath: "web-ui-components/lib/molecules/tables"
}, {
  name: "DataTable",
  path: "molecules/tables/Table/DataTable",
  styleguidePath: "Molecules/Tables/Table/DataTable",
  importPath: "web-ui-components/lib/molecules/tables/table"
}, {
  name: "Table",
  path: "molecules/tables/Table/Table",
  styleguidePath: "Molecules/Tables/Table/Table",
  importPath: "web-ui-components/lib/molecules/tables/table"
}, {
  name: "TableBody",
  path: "molecules/tables/Table/TableBody",
  styleguidePath: "Molecules/Tables/Table/TableBody",
  importPath: "web-ui-components/lib/molecules/tables/table"
}, {
  name: "TableBodyData",
  path: "molecules/tables/Table/TableBodyData",
  styleguidePath: "Molecules/Tables/Table/TableBodyData",
  importPath: "web-ui-components/lib/molecules/tables/table"
}, {
  name: "TableHead",
  path: "molecules/tables/Table/TableHead",
  styleguidePath: "Molecules/Tables/Table/TableHead",
  importPath: "web-ui-components/lib/molecules/tables/table"
}, {
  name: "TableHeadData",
  path: "molecules/tables/Table/TableHeadData",
  styleguidePath: "Molecules/Tables/Table/TableHeadData",
  importPath: "web-ui-components/lib/molecules/tables/table"
}, {
  name: "TableRow",
  path: "molecules/tables/Table/TableRow",
  styleguidePath: "Molecules/Tables/Table/TableRow",
  importPath: "web-ui-components/lib/molecules/tables/table"
}, {
  name: "SectionHeading",
  path: "molecules/text/SectionHeading",
  styleguidePath: "Molecules/Text/SectionHeading",
  importPath: "web-ui-components/lib/molecules/text"
}, {
  name: "ConfirmationTile",
  path: "molecules/tile/ConfirmationTile",
  styleguidePath: "Molecules/Tile/ConfirmationTile",
  importPath: "web-ui-components/lib/molecules/tile"
}, {
  name: "ExclamationTile",
  path: "molecules/tile/ExclamationTile",
  styleguidePath: "Molecules/Tile/ExclamationTile",
  importPath: "web-ui-components/lib/molecules/tile"
}, {
  name: "HighlightTile",
  path: "molecules/tile/HighlightTile",
  styleguidePath: "Molecules/Tile/HighlightTile",
  importPath: "web-ui-components/lib/molecules/tile"
}, {
  name: "IconTile",
  path: "molecules/tile/IconTile",
  styleguidePath: "Molecules/Tile/IconTile",
  importPath: "web-ui-components/lib/molecules/tile"
}, {
  name: "NumberedTile",
  path: "molecules/tile/NumberedTile",
  styleguidePath: "Molecules/Tile/NumberedTile",
  importPath: "web-ui-components/lib/molecules/tile"
}, {
  name: "Tile",
  path: "molecules/tile/Tile",
  styleguidePath: "Molecules/Tile/Tile",
  importPath: "web-ui-components/lib/molecules/tile"
}, {
  name: "TileSector",
  path: "molecules/tile/Tile/TileSector",
  styleguidePath: "Molecules/Tile/Tile/TileSector",
  importPath: "web-ui-components/lib/molecules/tile/tile"
}, {
  name: "TileSegment",
  path: "molecules/tile/Tile/TileSegment",
  styleguidePath: "Molecules/Tile/Tile/TileSegment",
  importPath: "web-ui-components/lib/molecules/tile/tile"
}, {
  name: "ToggleOption",
  path: "molecules/toggle/ToggleOption",
  styleguidePath: "Molecules/Toggle/ToggleOption",
  importPath: "web-ui-components/lib/molecules/toggle"
}, {
  name: "NavigationButton",
  path: "navigation/buttons/NavigationButton",
  styleguidePath: "Navigation/Buttons/NavigationButton",
  importPath: "web-ui-components/lib/navigation/buttons"
}, {
  name: "NavigationButtonGroup",
  path: "navigation/buttons/NavigationButtonGroup",
  styleguidePath: "Navigation/Buttons/NavigationButtonGroup",
  importPath: "web-ui-components/lib/navigation/buttons"
}, {
  name: "ProgressStepper",
  path: "navigation/indicators/ProgressStepper",
  styleguidePath: "Navigation/Indicators/ProgressStepper",
  importPath: "web-ui-components/lib/navigation/indicators"
}, {
  name: "MainNavLink",
  path: "navigation/nav-links/MainNavLink",
  styleguidePath: "Navigation/Nav-links/MainNavLink",
  importPath: "web-ui-components/lib/navigation/nav-links"
}, {
  name: "Paginator",
  path: "navigation/pagination/Paginator",
  styleguidePath: "Navigation/Pagination/Paginator",
  importPath: "web-ui-components/lib/navigation/pagination"
}, {
  name: "PaginatorNextButton",
  path: "navigation/pagination/Paginator/PaginatorNextButton",
  styleguidePath: "Navigation/Pagination/Paginator/PaginatorNextButton",
  importPath: "web-ui-components/lib/navigation/pagination/paginator"
}, {
  name: "PaginatorPageButton",
  path: "navigation/pagination/Paginator/PaginatorPageButton",
  styleguidePath: "Navigation/Pagination/Paginator/PaginatorPageButton",
  importPath: "web-ui-components/lib/navigation/pagination/paginator"
}, {
  name: "PaginatorPreviousButton",
  path: "navigation/pagination/Paginator/PaginatorPreviousButton",
  styleguidePath: "Navigation/Pagination/Paginator/PaginatorPreviousButton",
  importPath: "web-ui-components/lib/navigation/pagination/paginator"
}, {
  name: "MainSiteNav",
  path: "navigation/site-navs/MainSiteNav",
  styleguidePath: "Navigation/Site-navs/MainSiteNav",
  importPath: "web-ui-components/lib/navigation/site-navs"
}, {
  name: "MobileMainSiteNav",
  path: "navigation/site-navs/MobileMainSiteNav",
  styleguidePath: "Navigation/Site-navs/MobileMainSiteNav",
  importPath: "web-ui-components/lib/navigation/site-navs"
}, {
  name: "UtilityNav",
  path: "navigation/site-navs/UtilityNav",
  styleguidePath: "Navigation/Site-navs/UtilityNav",
  importPath: "web-ui-components/lib/navigation/site-navs"
}, {
  name: "UtilityNavButton",
  path: "navigation/site-navs/UtilityNavButton",
  styleguidePath: "Navigation/Site-navs/UtilityNavButton",
  importPath: "web-ui-components/lib/navigation/site-navs"
}, {
  name: "TabCard",
  path: "navigation/tab-cards/TabCard",
  styleguidePath: "Navigation/Tab-cards/TabCard",
  importPath: "web-ui-components/lib/navigation/tab-cards"
}, {
  name: "TabCardBlock",
  path: "navigation/tab-cards/TabCardBlock",
  styleguidePath: "Navigation/Tab-cards/TabCardBlock",
  importPath: "web-ui-components/lib/navigation/tab-cards"
}, {
  name: "TabCardSmall",
  path: "navigation/tab-cards/TabCardSmall",
  styleguidePath: "Navigation/Tab-cards/TabCardSmall",
  importPath: "web-ui-components/lib/navigation/tab-cards"
}, {
  name: "TabGroup",
  path: "navigation/tab-group/TabGroup",
  styleguidePath: "Navigation/Tab-group/TabGroup",
  importPath: "web-ui-components/lib/navigation/tab-group"
}, {
  name: "TabButton",
  path: "navigation/tab-group/TabGroup/TabButton",
  styleguidePath: "Navigation/Tab-group/TabGroup/TabButton",
  importPath: "web-ui-components/lib/navigation/tab-group/tabGroup"
}, {
  name: "TransferTakeover",
  path: "navigation/takeovers/TransferTakeover",
  styleguidePath: "Navigation/Takeovers/TransferTakeover",
  importPath: "web-ui-components/lib/navigation/takeovers"
}, {
  name: "Card",
  path: "organisms/cards/Card",
  styleguidePath: "Organisms/Cards/Card",
  importPath: "web-ui-components/lib/organisms/cards"
}, {
  name: "DistinctiveLinkCard",
  path: "organisms/cards/DistinctiveLinkCard",
  styleguidePath: "Organisms/Cards/DistinctiveLinkCard",
  importPath: "web-ui-components/lib/organisms/cards"
}, {
  name: "FilterAction",
  path: "organisms/filters/Filter/FilterActionGroup/FilterAction",
  styleguidePath: "Organisms/Filters/Filter/FilterActionGroup/FilterAction",
  importPath: "web-ui-components/lib/organisms/filters/filter/filterActionGroup"
}, {
  name: "FilterActionGroup",
  path: "organisms/filters/Filter/FilterActionGroup",
  styleguidePath: "Organisms/Filters/Filter/FilterActionGroup",
  importPath: "web-ui-components/lib/organisms/filters/filter"
}, {
  name: "FilterSector",
  path: "organisms/filters/Filter/FilterSector",
  styleguidePath: "Organisms/Filters/Filter/FilterSector",
  importPath: "web-ui-components/lib/organisms/filters/filter"
}, {
  name: "FilterSegment",
  path: "organisms/filters/Filter/FilterSegmentGroup/FilterSegment",
  styleguidePath: "Organisms/Filters/Filter/FilterSegmentGroup/FilterSegment",
  importPath: "web-ui-components/lib/organisms/filters/filter/filterSegmentGroup"
}, {
  name: "FilterSegmentGroup",
  path: "organisms/filters/Filter/FilterSegmentGroup",
  styleguidePath: "Organisms/Filters/Filter/FilterSegmentGroup",
  importPath: "web-ui-components/lib/organisms/filters/filter"
}, {
  name: "FilterSubSegment",
  path: "organisms/filters/Filter/FilterSubSegmentGroup/FilterSubSegment",
  styleguidePath: "Organisms/Filters/Filter/FilterSubSegmentGroup/FilterSubSegment",
  importPath: "web-ui-components/lib/organisms/filters/filter/filterSubSegmentGroup"
}, {
  name: "FilterSubSegmentGroup",
  path: "organisms/filters/Filter/FilterSubSegmentGroup",
  styleguidePath: "Organisms/Filters/Filter/FilterSubSegmentGroup",
  importPath: "web-ui-components/lib/organisms/filters/filter"
}, {
  name: "Filter",
  path: "organisms/filters/Filter",
  styleguidePath: "Organisms/Filters/Filter",
  importPath: "web-ui-components/lib/organisms/filters"
}, {
  name: "GlobalHeader",
  path: "organisms/global/GlobalHeader",
  styleguidePath: "Organisms/Global/GlobalHeader",
  importPath: "web-ui-components/lib/organisms/global"
}, {
  name: "HeroHeader",
  path: "organisms/global/HeroHeader",
  styleguidePath: "Organisms/Global/HeroHeader",
  importPath: "web-ui-components/lib/organisms/global"
}, {
  name: "CentredModal",
  path: "organisms/modals/CentredModal",
  styleguidePath: "Organisms/Modals/CentredModal",
  importPath: "web-ui-components/lib/organisms/modals"
}, {
  name: "ConfirmationModal",
  path: "organisms/modals/ConfirmationModal",
  styleguidePath: "Organisms/Modals/ConfirmationModal",
  importPath: "web-ui-components/lib/organisms/modals"
}, {
  name: "Loader",
  path: "organisms/modals/Loader",
  styleguidePath: "Organisms/Modals/Loader",
  importPath: "web-ui-components/lib/organisms/modals"
}, {
  name: "ModalBody",
  path: "organisms/modals/Modal/ModalBody",
  styleguidePath: "Organisms/Modals/Modal/ModalBody",
  importPath: "web-ui-components/lib/organisms/modals/modal"
}, {
  name: "ModalContainer",
  path: "organisms/modals/Modal/ModalContainer",
  styleguidePath: "Organisms/Modals/Modal/ModalContainer",
  importPath: "web-ui-components/lib/organisms/modals/modal"
}, {
  name: "ModalHeader",
  path: "organisms/modals/Modal/ModalHeader",
  styleguidePath: "Organisms/Modals/Modal/ModalHeader",
  importPath: "web-ui-components/lib/organisms/modals/modal"
}, {
  name: "Modal",
  path: "organisms/modals/Modal",
  styleguidePath: "Organisms/Modals/Modal",
  importPath: "web-ui-components/lib/organisms/modals"
}, {
  name: "UnfinishedWorkModal",
  path: "organisms/modals/UnfinishedWorkModal",
  styleguidePath: "Organisms/Modals/UnfinishedWorkModal",
  importPath: "web-ui-components/lib/organisms/modals"
}, {
  name: "DisableTakeover",
  path: "organisms/takeovers/DisableTakeover",
  styleguidePath: "Organisms/Takeovers/DisableTakeover",
  importPath: "web-ui-components/lib/organisms/takeovers"
}, {
  name: "LoadingLocalTakeover",
  path: "organisms/takeovers/LoadingLocalTakeover",
  styleguidePath: "Organisms/Takeovers/LoadingLocalTakeover",
  importPath: "web-ui-components/lib/organisms/takeovers"
}, {
  name: "Timeline",
  path: "organisms/timelines/Timeline",
  styleguidePath: "Organisms/Timelines/Timeline",
  importPath: "web-ui-components/lib/organisms/timelines"
}, {
  name: "LoanReasonSelector",
  path: "products/selection/LoanReasonSelector",
  styleguidePath: "Products/Selection/LoanReasonSelector",
  importPath: "web-ui-components/lib/products/selection"
}, {
  name: "ProductSelector",
  path: "products/selection/ProductSelector",
  styleguidePath: "Products/Selection/ProductSelector",
  importPath: "web-ui-components/lib/products/selection"
}, {
  name: "EmailCreationInput",
  path: "security/authentication/inputs/EmailCreationInput",
  styleguidePath: "Security/Authentication/Inputs/EmailCreationInput",
  importPath: "web-ui-components/lib/security/authentication/inputs"
}, {
  name: "PasswordCreationInput",
  path: "security/authentication/inputs/PasswordCreationInput",
  styleguidePath: "Security/Authentication/Inputs/PasswordCreationInput",
  importPath: "web-ui-components/lib/security/authentication/inputs"
}, {
  name: "CallButton",
  path: "telephony/Buttons/CallButton",
  styleguidePath: "Telephony/Buttons/CallButton",
  importPath: "web-ui-components/lib/telephony/buttons"
}, {
  name: "CallStatus",
  path: "telephony/Statuses/CallStatus",
  styleguidePath: "Telephony/Statuses/CallStatus",
  importPath: "web-ui-components/lib/telephony/statuses"
}, {
  name: "Footer",
  path: "typography/ancillary/Footer",
  styleguidePath: "Typography/Ancillary/Footer",
  importPath: "web-ui-components/lib/typography/ancillary"
}, {
  name: "LargeBody",
  path: "typography/body/LargeBody",
  styleguidePath: "Typography/Body/LargeBody",
  importPath: "web-ui-components/lib/typography/body"
}, {
  name: "SmallestBody",
  path: "typography/body/SmallestBody",
  styleguidePath: "Typography/Body/SmallestBody",
  importPath: "web-ui-components/lib/typography/body"
}, {
  name: "StandardBody",
  path: "typography/body/StandardBody",
  styleguidePath: "Typography/Body/StandardBody",
  importPath: "web-ui-components/lib/typography/body"
}, {
  name: "SubBody",
  path: "typography/body/SubBody",
  styleguidePath: "Typography/Body/SubBody",
  importPath: "web-ui-components/lib/typography/body"
}, {
  name: "PageHeading",
  path: "typography/headings/PageHeading",
  styleguidePath: "Typography/Headings/PageHeading",
  importPath: "web-ui-components/lib/typography/headings"
}, {
  name: "SectionHeading",
  path: "typography/headings/SectionHeading",
  styleguidePath: "Typography/Headings/SectionHeading",
  importPath: "web-ui-components/lib/typography/headings"
}, {
  name: "SubHeading",
  path: "typography/headings/SubHeading",
  styleguidePath: "Typography/Headings/SubHeading",
  importPath: "web-ui-components/lib/typography/headings"
}, {
  name: "SubsectionHeading",
  path: "typography/headings/SubsectionHeading",
  styleguidePath: "Typography/Headings/SubsectionHeading",
  importPath: "web-ui-components/lib/typography/headings"
}, {
  name: "LargeHero",
  path: "typography/heros/LargeHero",
  styleguidePath: "Typography/Heros/LargeHero",
  importPath: "web-ui-components/lib/typography/heros"
}, {
  name: "StandardHero",
  path: "typography/heros/StandardHero",
  styleguidePath: "Typography/Heros/StandardHero",
  importPath: "web-ui-components/lib/typography/heros"
}, {
  name: "IndicativeHighlight",
  path: "typography/highlights/IndicativeHighlight",
  styleguidePath: "Typography/Highlights/IndicativeHighlight",
  importPath: "web-ui-components/lib/typography/highlights"
}, {
  name: "StateIndicator",
  path: "typography/indicators/StateIndicator",
  styleguidePath: "Typography/Indicators/StateIndicator",
  importPath: "web-ui-components/lib/typography/indicators"
}, {
  name: "FieldLabel",
  path: "typography/labels/FieldLabel",
  styleguidePath: "Typography/Labels/FieldLabel",
  importPath: "web-ui-components/lib/typography/labels"
}, {
  name: "ProminentLabel",
  path: "typography/labels/ProminentLabel",
  styleguidePath: "Typography/Labels/ProminentLabel",
  importPath: "web-ui-components/lib/typography/labels"
}, {
  name: "StandardLabel",
  path: "typography/labels/StandardLabel",
  styleguidePath: "Typography/Labels/StandardLabel",
  importPath: "web-ui-components/lib/typography/labels"
}, {
  name: "SubLabel",
  path: "typography/labels/SubLabel",
  styleguidePath: "Typography/Labels/SubLabel",
  importPath: "web-ui-components/lib/typography/labels"
}, {
  name: "BulletList",
  path: "typography/lists/BulletList",
  styleguidePath: "Typography/Lists/BulletList",
  importPath: "web-ui-components/lib/typography/lists"
}, {
  name: "NumberList",
  path: "typography/lists/NumberList",
  styleguidePath: "Typography/Lists/NumberList",
  importPath: "web-ui-components/lib/typography/lists"
}, {
  name: "TickList",
  path: "typography/lists/TickList",
  styleguidePath: "Typography/Lists/TickList",
  importPath: "web-ui-components/lib/typography/lists"
}, {
  name: "Identifier",
  path: "typography/modifiers/Identifier",
  styleguidePath: "Typography/Modifiers/Identifier",
  importPath: "web-ui-components/lib/typography/modifiers"
}, {
  name: "AbbreviatedTag",
  path: "typography/tags/AbbreviatedTag",
  styleguidePath: "Typography/Tags/AbbreviatedTag",
  importPath: "web-ui-components/lib/typography/tags"
}, {
  name: "StatusTag",
  path: "typography/tags/StatusTag",
  styleguidePath: "Typography/Tags/StatusTag",
  importPath: "web-ui-components/lib/typography/tags"
}, {
  name: "ValueTag",
  path: "typography/tags/ValueTag",
  styleguidePath: "Typography/Tags/ValueTag",
  importPath: "web-ui-components/lib/typography/tags"
}, {
  name: "StandardValue",
  path: "typography/values/StandardValue",
  styleguidePath: "Typography/Values/StandardValue",
  importPath: "web-ui-components/lib/typography/values"
}, {
  name: "UserStatusBandCard",
  path: "users/business-users/cards/UserStatusBandCard",
  styleguidePath: "Users/Business-users/Cards/UserStatusBandCard",
  importPath: "web-ui-components/lib/users/business-users/cards"
}];
var deprecated = [{
  name: "InputRadio",
  path: "src/actions/radios/InputRadio/package.json",
  deprecations: [{
    replacements: {
      name: "GenericRadio",
      path: "Data/Capture/Radios"
    }
  }],
  deprecationVersion: "23.4.0",
  deprecationDate: "February 17 2020"
}, {
  name: "InputRadioGroup",
  path: "src/actions/radios/InputRadioGroup/package.json",
  deprecations: [{
    replacements: {
      name: "GenericRadio",
      path: "Data/Capture/Radios"
    }
  }],
  deprecationVersion: "23.4.0",
  deprecationDate: "February 17 2020"
}, {
  name: "Anchor",
  path: "src/atoms/buttons/Anchor/package.json",
  deprecations: [{
    replacements: {
      name: "WebsiteLink",
      path: "Actions/Links"
    }
  }],
  deprecationVersion: "25.4.0",
  deprecationDate: "May 01 2020"
}, {
  name: "Checkbox",
  path: "src/atoms/forms/Checkbox/package.json",
  deprecations: [{
    replacements: {
      name: "GenericCheckbox",
      path: "Data/Capture/Checkboxes"
    }
  }],
  deprecationVersion: "25.4.0",
  deprecationDate: "May 01 2020"
}, {
  name: "Datepicker",
  path: "src/atoms/forms/Datepicker/package.json",
  deprecations: [{
    replacements: {
      name: "Calendar",
      path: "Atoms/Forms"
    }
  }],
  deprecationVersion: "7.3.0",
  deprecationDate: "August 30 2018"
}, {
  name: "Radio",
  path: "src/atoms/forms/Radio/package.json",
  deprecations: [{
    replacements: {
      name: "GenericRadio",
      path: "Data/Capture/Radios"
    }
  }],
  deprecationVersion: "23.2.0",
  deprecationDate: "February 06 2020"
}, {
  name: "RadioCard",
  path: "src/atoms/forms/RadioCard/package.json",
  deprecations: [{
    replacements: {
      name: "GenericRadio",
      path: "Data/Capture/Radios"
    }
  }],
  deprecationVersion: "25.4.0",
  deprecationDate: "May 01 2020"
}, {
  name: "Select",
  path: "src/atoms/forms/Select/package.json",
  deprecations: [{
    replacements: {
      name: "GenericSelect",
      path: "Data/Capture/Selects"
    }
  }],
  deprecationVersion: "24.0.0",
  deprecationDate: "February 27 2020"
}, {
  name: "Textarea",
  path: "src/atoms/forms/Textarea/package.json",
  deprecations: [{
    replacements: {
      name: "GenericTextArea",
      path: "Data/Capture/TextAreas"
    }
  }],
  deprecationVersion: "19.0.0",
  deprecationDate: "May 03 2019"
}, {
  name: "TextAreaCharacterCount",
  path: "src/atoms/forms/TextAreaCharacterCount/package.json",
  deprecations: [{
    replacements: {
      name: "GenericTextArea",
      path: "Data/Capture/TextAreas"
    }
  }],
  deprecationVersion: "20.0.0",
  deprecationDate: "May 15 2019"
}, {
  name: "Icon",
  path: "src/atoms/iconography/Icon/package.json",
  deprecations: [{
    replacements: {
      name: "ChevronLeftSmall",
      replacement: "ChevronLeftSolidSmall",
      path: "Atoms/Iconography"
    }
  }, {
    replacements: {
      name: "crossOutlineLarge",
      replacement: "CrossOutlineLarge",
      path: "Atoms/Iconography"
    }
  }, {
    replacements: {
      name: "crossOutlineSmall",
      replacement: "CrossOutlineSmall",
      path: "Atoms/Iconography"
    }
  }, {
    replacements: {
      name: "crossOutlineSmall",
      replacement: "CrossOutlineSmall",
      path: "Atoms/Iconography"
    }
  }, {
    replacements: {
      name: "CrossRoundedSolidLarge",
      replacement: "CrossSolidLarge",
      path: "Atoms/Iconography"
    }
  }, {
    replacements: {
      name: "CrossRoundedSolidSmall",
      replacement: "CrossSolidSmall",
      path: "Atoms/Iconography"
    }
  }, {
    replacements: {
      name: "CycleSolidLarge",
      replacement: "CycleLarge",
      path: "Atoms/Iconography"
    }
  }, {
    replacements: {
      name: "CycleSolidSmall",
      replacement: "CycleSmall",
      path: "Atoms/Iconography"
    }
  }]
}, {
  name: "Divider",
  path: "src/atoms/layout/Divider/package.json",
  deprecations: [{
    replacements: {
      name: "GenericDivider",
      path: "Layout/Content/Breaks"
    }
  }],
  deprecationVersion: "23.1.0",
  deprecationDate: "January 31 2020"
}, {
  name: "BankHeader",
  path: "src/atoms/logo/BankHeader/package.json",
  deprecations: [{
    replacements: {
      name: "ContainedHeader",
      path: "Layout/Headers"
    }
  }],
  deprecationVersion: "23.1.0",
  deprecationDate: "January 31 2020"
}, {
  name: "Header",
  path: "src/atoms/logo/Header/package.json",
  deprecations: [{
    replacements: {
      name: "ContainedHeader",
      path: "Layout/Headers"
    }
  }],
  deprecationVersion: "23.1.0",
  deprecationDate: "January 31 2020"
}, {
  name: "BulletedList",
  path: "src/atoms/text/BulletedList/package.json",
  deprecations: [{
    replacements: {
      name: "BulletList",
      path: "Typography/Lists"
    }
  }],
  deprecationVersion: "23.1.0",
  deprecationDate: "January 31 2020"
}, {
  name: "Callout",
  path: "src/atoms/text/Callout/package.json",
  deprecations: [{
    replacements: {
      name: "ConditionalPanel",
      path: "Layout/Content/Panels"
    }
  }],
  deprecationVersion: "25.4.0",
  deprecationDate: "May 01 2020"
}, {
  name: "NumberedList",
  path: "src/atoms/text/NumberedList/package.json",
  deprecations: [{
    replacements: {
      name: "NumberList",
      path: "Typography/Lists"
    }
  }],
  deprecationVersion: "24.0.0",
  deprecationDate: "February 27 2020"
}, {
  name: "TextBody",
  path: "src/atoms/text/TextBody/package.json",
  deprecations: [{
    replacements: {
      name: "StandardBody",
      path: "Typography/Body"
    }
  }],
  deprecationVersion: "22.3.0",
  deprecationDate: "August 05 2019"
}, {
  name: "TextStyled",
  path: "src/atoms/text/TextStyled/package.json",
  deprecations: [{
    replacements: {
      name: "Typography",
      path: "Typography"
    }
  }],
  deprecationVersion: "22.3.0",
  deprecationDate: "August 05 2019"
}, {
  name: "TheSmallPrint",
  path: "src/atoms/text/TheSmallPrint/package.json",
  deprecations: [{
    replacements: {
      name: "SmallestBody",
      path: "Typography/Body"
    }
  }],
  deprecationVersion: "25.4.0",
  deprecationDate: "May 01 2020"
}, {
  name: "Title",
  path: "src/atoms/text/Title/package.json",
  deprecations: [{
    replacements: {
      name: "Headings",
      path: "Typography"
    }
  }],
  deprecationVersion: "25.4.0",
  deprecationDate: "May 01 2020"
}, {
  name: "GenericTextInput",
  path: "src/data/capture/inputs/GenericTextInput/package.json",
  deprecations: [{
    replacements: {
      name: "GenericAlphaNumericInput",
      path: "Data/Capture/Inputs"
    }
  }],
  deprecationVersion: "25.1.0",
  deprecationDate: "March 23 2020"
}, {
  name: "PrintButton",
  path: "src/documents/printing/buttons/PrintButton/package.json",
  deprecations: [{
    replacements: {
      name: "ActionButton",
      path: "Actions/Buttons/ActionButton"
    }
  }],
  deprecationVersion: "25.4.0",
  deprecationDate: "May 01 2020"
}, {
  name: "AccountLegacyPanel",
  path: "src/finance/accounts/panels/AccountLegacyPanel/package.json",
  deprecations: [{
    replacements: {
      name: "AccountBalancesSelectPanel",
      path: "Finance/Accounts/Panels"
    }
  }],
  deprecationVersion: "22.1.0",
  deprecationDate: "July 17 2019"
}, {
  name: "Container",
  path: "src/global/layout/Container/package.json",
  deprecations: [{
    replacements: {
      name: "ContentContainer",
      path: "Layout/Sections"
    }
  }],
  deprecationVersion: "23.1.0",
  deprecationDate: "January 31 2020"
}, {
  name: "HeaderSection",
  path: "src/global/layout/Pages/HeaderSection/package.json",
  deprecations: [{
    replacements: {
      name: "ContainedHeader",
      path: "Layout/Headers"
    }
  }],
  deprecationVersion: "23.1.0",
  deprecationDate: "January 31 2020"
}, {
  name: "ServicingSection",
  path: "src/global/layout/Pages/ServicingSection/package.json",
  deprecations: [{
    replacements: {
      name: "DataManagementShell",
      path: "Layout/Shells"
    }
  }],
  deprecationVersion: "25.4.0",
  deprecationDate: "May 01 2020"
}, {
  name: "WorkflowSection",
  path: "src/global/layout/Pages/WorkflowSection/package.json",
  deprecations: [{
    replacements: {
      name: "ApplicationFormShell",
      path: "Layout/Shells"
    }
  }],
  deprecationVersion: "25.4.0",
  deprecationDate: "May 01 2020"
}, {
  name: "ContentContainer",
  path: "src/layout/containers/ContentContainer/package.json",
  deprecations: [{
    replacements: {
      name: "ApplicationFormShell",
      path: "Layout/Shells"
    }
  }],
  deprecationVersion: "25.4.0",
  deprecationDate: "May 01 2020"
}, {
  name: "Main",
  path: "src/layout/containers/Main/package.json",
  deprecations: [{
    replacements: {
      name: "ApplicationFormShell",
      path: "Layout/Shells/ApplicationFormShell"
    }
  }],
  deprecationVersion: "23.1.0",
  deprecationDate: "January 31 2020"
}, {
  name: "GuidanceTile",
  path: "src/layout/content/tiles/GuidanceTile/package.json",
  deprecations: [{
    replacements: {
      name: "StandoutTile",
      path: "Layout/Content/Tiles"
    }
  }],
  deprecationVersion: "25.4.0",
  deprecationDate: "May 01 2020"
}, {
  name: "RecapTile",
  path: "src/layout/content/tiles/RecapTile/package.json",
  deprecations: [{
    replacements: {
      name: "StandoutTile",
      path: "Layout/Content/Tiles"
    }
  }],
  deprecationVersion: "25.4.0",
  deprecationDate: "May 01 2020"
}, {
  name: "FixedFooter",
  path: "src/layout/sections/footers/FixedFooter/package.json",
  deprecations: [{
    replacements: {
      name: "MainFixedFooter",
      path: "Layout/Footers"
    }
  }],
  deprecationVersion: "23.1.0",
  deprecationDate: "January 31 2020"
}, {
  name: "AccordionItem",
  path: "src/molecules/accordions/Accordion/AccordionItem/package.json",
  deprecations: [{
    replacements: {
      name: "GenericAccordion",
      path: "Layout/Content/Accordions"
    }
  }],
  deprecationVersion: "25.4.0",
  deprecationDate: "May 01 2020"
}, {
  name: "Accordion",
  path: "src/molecules/accordions/Accordion/package.json",
  deprecations: [{
    replacements: {
      name: "GenericAccordion",
      path: "Layout/Content/Accordions"
    }
  }],
  deprecationVersion: "25.4.0",
  deprecationDate: "May 01 2020"
}, {
  name: "AccordionTable",
  path: "src/molecules/accordions/AccordionTable/package.json",
  deprecations: [{
    replacements: {
      name: "GenericAccordion",
      path: "Layout/Content/Accordions"
    }
  }],
  deprecationVersion: "25.4.0",
  deprecationDate: "May 01 2020"
}, {
  name: "ContentReveal",
  path: "src/molecules/accordions/ContentReveal/package.json",
  deprecations: [{
    replacements: {
      name: "ContentRevealPanel",
      path: "Layout/Content/Panels"
    }
  }],
  deprecationVersion: "24.1.0",
  deprecationDate: "March 05 2020"
}, {
  name: "ConfirmationCheckbox",
  path: "src/molecules/forms/ConfirmationCheckbox/package.json",
  deprecations: [{
    replacements: {
      name: "StandaloneCheckbox",
      path: "Data/Capture/Checkboxes"
    }
  }],
  deprecationVersion: "25.4.0",
  deprecationDate: "May 01 2020"
}, {
  name: "DaySelector",
  path: "src/molecules/forms/DaySelector/package.json",
  deprecations: [{
    replacements: {
      name: "GenericRadio",
      path: "Data/Capture/Radios"
    }
  }],
  deprecationVersion: "25.4.0",
  deprecationDate: "May 01 2020"
}, {
  name: "RadioCardGroup",
  path: "src/molecules/forms/RadioCardGroup/package.json",
  deprecations: [{
    replacements: {
      name: "GenericRadio",
      path: "Data/Capture/Radios"
    }
  }],
  deprecationVersion: "25.4.0",
  deprecationDate: "May 01 2020"
}, {
  name: "ValidationMessage",
  path: "src/molecules/forms/ValidationMessage/package.json",
  deprecations: [{
    replacements: {
      name: "ValidationMessageTile",
      path: "Layout/Tiles"
    }
  }],
  deprecationVersion: "22.22.0",
  deprecationDate: "January 20 2020"
}, {
  name: "IconText",
  path: "src/molecules/icon-text/IconText/package.json",
  deprecations: [{
    replacements: {
      name: "IconTextDynamic",
      path: "Molecules/IconTextDynamic"
    }
  }],
  deprecationVersion: "6.4.0",
  deprecationDate: "August 03 2018"
}, {
  name: "BackAnchor",
  path: "src/molecules/navigation/BackAnchor/package.json",
  deprecations: [{
    replacements: {
      name: "WebsiteLink",
      path: "Actions/Links"
    }
  }],
  deprecationVersion: "25.4.0",
  deprecationDate: "May 01 2020"
}, {
  name: "BackButton",
  path: "src/molecules/navigation/BackButton/package.json",
  deprecations: [{
    replacements: {
      name: "UtilityNavButton",
      path: "Navigation/Site-navs"
    }
  }],
  deprecationVersion: "25.5.0",
  deprecationDate: "May 13 2020"
}, {
  name: "Utility",
  path: "src/molecules/navigation/Utility/package.json",
  deprecations: [{
    replacements: {
      name: "UtilityNav",
      path: "Navigation/Site-Navs/UtilityNav"
    }
  }],
  deprecationVersion: "22.12.0",
  deprecationDate: "September 27 2019"
}, {
  name: "SubordinatePanel",
  path: "src/molecules/panels/SubordinatePanel/package.json",
  deprecations: [{
    replacements: {
      name: "ConditionalPanel",
      path: "Layout/Content/Panels"
    }
  }],
  deprecationVersion: "23.1.0",
  deprecationDate: "January 31 2020"
}, {
  name: "ProgressIndicator",
  path: "src/molecules/progress/ProgressIndicator/package.json",
  deprecations: [{
    replacements: {
      name: "ProgressStepper",
      path: "Navigation/Indicators"
    }
  }],
  deprecationVersion: "26.0.0",
  deprecationDate: "May 22 2020"
}, {
  name: "ProgressIndicatorItem",
  path: "src/molecules/progress/ProgressIndicator/ProgressIndicatorItem/package.json",
  deprecations: [{
    replacements: {
      name: "ProgressStepper",
      path: "Navigation/Indicators"
    }
  }],
  deprecationVersion: "26.0.0",
  deprecationDate: "May 22 2020"
}, {
  name: "SectionHeading",
  path: "src/molecules/text/SectionHeading/package.json",
  deprecations: [{
    replacements: {
      name: "SectionHeading",
      path: "Typography/Headings"
    }
  }],
  deprecationVersion: "23.2.0",
  deprecationDate: "February 06 2020"
}, {
  name: "ConfirmationTile",
  path: "src/molecules/tile/ConfirmationTile/package.json",
  deprecations: [{
    replacements: {
      name: "OutcomeTile",
      path: "Layout/Content/Tiles"
    }
  }],
  deprecationVersion: "25.4.0",
  deprecationDate: "May 01 2020"
}, {
  name: "HighlightTile",
  path: "src/molecules/tile/HighlightTile/package.json",
  deprecations: [{
    replacements: {
      name: "StandoutTile",
      path: "Layout/Content/Tiles"
    }
  }],
  deprecationVersion: "25.4.0",
  deprecationDate: "May 01 2020"
}, {
  name: "IconTile",
  path: "src/molecules/tile/IconTile/package.json",
  deprecations: [{
    replacements: {
      name: "OutcomeTile",
      path: "Layout/Content/Tiles"
    }
  }],
  deprecationVersion: "25.4.0",
  deprecationDate: "May 01 2020"
}, {
  name: "GlobalHeader",
  path: "src/organisms/global/GlobalHeader/package.json",
  deprecations: [{
    replacements: {
      name: "ContainedHeader",
      path: "Layout/Headers"
    }
  }],
  deprecationVersion: "25.4.0",
  deprecationDate: "May 01 2020"
}, {
  name: "CentredModal",
  path: "src/organisms/modals/CentredModal/package.json",
  deprecations: [{
    replacements: {
      name: "ConfirmationModal",
      path: "Organisms/Modals"
    }
  }],
  deprecationVersion: "22.0.0",
  deprecationDate: "July 04 2019"
}, {
  name: "Modal",
  path: "src/organisms/modals/Modal/package.json",
  deprecations: [{
    replacements: {
      name: "ConfirmationModal",
      path: "Organisms/Modals"
    }
  }],
  deprecationVersion: "22.0.0",
  deprecationDate: "July 04 2019"
}, {
  name: "LargeHero",
  path: "src/typography/heros/LargeHero/package.json",
  deprecations: [{
    replacements: {
      name: "Typography",
      path: "Typography"
    }
  }],
  deprecationVersion: "24.0.0",
  deprecationDate: "February 27 2020"
}, {
  name: "StandardHero",
  path: "src/typography/heros/StandardHero/package.json",
  deprecations: [{
    replacements: {
      name: "Typography",
      path: "Typography"
    }
  }],
  deprecationVersion: "24.0.0",
  deprecationDate: "February 27 2020"
}];
/* eslint-disable no-console */

var deprecatedDictComponents = {};
var deprecatedDictProps = {};
var timeoutDelay = 100;
var CONSOLE_DEPRECATION_MESSAGE_START = 'Deprecation: web-ui-components';
var DeprecationWarnings = {
  logComponent: function logComponent(componentName) {
    var deprecatedComponentObj = componentPaths.find(function (_ref) {
      var name = _ref.name;
      return name === componentName;
    });
    var oldPath = deprecatedComponentObj.styleguidePath;
    deprecatedComponentObj = deprecated.find(function (_ref2) {
      var name = _ref2.name;
      return name.includes(componentName);
    });
    var newPath = deprecatedComponentObj.deprecations[0].replacements.path + '/' + deprecatedComponentObj.deprecations[0].replacements.name;
    deprecatedDictComponents[componentName] = {
      oldPath: oldPath,
      newPath: newPath
    };
  },
  logIcon: function logIcon(componentName, deprecatedIcon) {
    var deprecatedComponentObj = componentPaths.find(function (_ref3) {
      var name = _ref3.name;
      return name.includes(componentName);
    });
    var path = deprecatedComponentObj.styleguidePath;
    var oldPath = path + ': ' + deprecatedIcon;
    var newPath = path + ': ' + deprecatedIcon;
    var iconName = componentName + ': ' + deprecatedIcon;
    deprecatedDictComponents[iconName] = {
      oldPath: oldPath,
      newPath: newPath
    };
  },
  logProp: function logProp(componentName, path, description) {
    deprecatedDictProps[componentName] = {
      path: path,
      description: description
    };
  },
  report: function report() {
    setTimeout(function () {
      var numberOfDeprecations = Object.keys(deprecatedDictComponents).length + Object.keys(deprecatedDictProps).length;

      if (numberOfDeprecations > 0) {
        console.groupCollapsed('Web UI Components Deprecation Warnings. Total: ' + numberOfDeprecations);
        console.groupCollapsed('Components. Total: ' + Object.keys(deprecatedDictComponents).length);
        Object.entries(deprecatedDictComponents).forEach(function (_ref4) {
          var _ref5 = slicedToArray(_ref4, 2),
              componentName = _ref5[0],
              info = _ref5[1];

          var oldPath = info.oldPath,
              newPath = info.newPath;
          console.groupCollapsed(componentName);
          console.warn('Deprecated:', oldPath);
          console.warn('Replacement:', newPath);
          console.groupEnd();
        });
        console.groupEnd();
        console.groupCollapsed('Props. Total: ' + Object.keys(deprecatedDictProps).length);
        Object.entries(deprecatedDictProps).forEach(function (_ref6) {
          var _ref7 = slicedToArray(_ref6, 2),
              componentName = _ref7[0],
              info = _ref7[1];

          var path = info.path,
              description = info.description;
          console.groupCollapsed(componentName);
          console.warn('Deprecated:', path);
          console.warn('Reason:', description);
          console.groupEnd();
        });
        console.groupEnd();
        console.groupEnd();
        deprecatedDictComponents = {};
        deprecatedDictProps = {};
      }
    }, timeoutDelay);
  },
  warn: function warn(message) {
    return console.warn(CONSOLE_DEPRECATION_MESSAGE_START + ' -> ' + message);
  }
};
Object.freeze(DeprecationWarnings);

var _templateObject$1 = taggedTemplateLiteral(['\n\t', ' ', ';\n\t', ';\n'], ['\n\t', ' ', ';\n\t', ';\n']);

var getFontProperties = function getFontProperties(props) {
  var fontProperties = 'font-size: 16px; line-height: 1.5;'; // TODOxCYBG To be revisited with responsive VM typography.
  // if (props.theme.name !== 'vm') {

  fontProperties = props.theme.isCompact ? fontSize('bute') : fontSize('jura'); // }

  return fontProperties;
};

var StyledStandardBody = styled('div')(_templateObject$1, getFontProperties, function (props) {
  return !props.isFlush && 'margin-bottom: ' + spacing.DOUBLE;
}, function (props) {
  return !props.isFlush && 'margin-right: ' + spacing.DOUBLE;
});
/**
 * @example ./Design.md
 */

var StandardBody = function StandardBody(_ref) {
  var isFlush = _ref.isFlush,
      children = _ref.children;
  return React.createElement(InternalComponentFrame.ActiveTypography, {
    componentName: 'StandardBody',
    hasCustomMargins: true
  }, React.createElement(StyledStandardBody, {
    isFlush: isFlush
  }, children));
};

StandardBody.propTypes = {
  /** Child content as node. Should be used to wrap bodies of textual content. This textual content
   * should contain appropriate HTML tagging and passing in orphan text child content should
   * be avoided. */
  children: PropTypes.node.isRequired,

  /** Removed margins. */
  isFlush: PropTypes.bool
};
StandardBody.defaultProps = {
  isFlush: false
};

StandardBody.defaultExample = function () {
  return React.createElement(StandardBody, null, React.createElement('p', null, 'StandardBody example'));
};

var _templateObject$2 = taggedTemplateLiteral(['\n\tcolor: ', ';\n\tlist-style: none;\n\tmargin-left: ', ';\n\tmargin-bottom: 0;\n\tmargin-top: 0;\n\tpadding-left: ', ';\n\n\tul {\n\t\tpadding-left: ', ';\n\t}\n'], ['\n\tcolor: ', ';\n\tlist-style: none;\n\tmargin-left: ', ';\n\tmargin-bottom: 0;\n\tmargin-top: 0;\n\tpadding-left: ', ';\n\n\tul {\n\t\tpadding-left: ', ';\n\t}\n']),
    _templateObject2$1 = taggedTemplateLiteral(['\n\tmargin-bottom: ', ';\n\tposition: relative;\n\n\t&:last-of-type {\n\t\tmargin-bottom: 0;\n\t}\n\n\t:before {\n\t\tcontent: \'\';\n\t\tposition: absolute;\n\t\tleft: -26px;\n\t\ttop: 10px;\n\t\twidth: 8px;\n\t\theight: 8px;\n\t\tborder: 1px solid ', ';\n\t\tbackground-color: ', ';\n\t\tborder-radius: ', ';\n\t}\n'], ['\n\tmargin-bottom: ', ';\n\tposition: relative;\n\n\t&:last-of-type {\n\t\tmargin-bottom: 0;\n\t}\n\n\t:before {\n\t\tcontent: \'\';\n\t\tposition: absolute;\n\t\tleft: -26px;\n\t\ttop: 10px;\n\t\twidth: 8px;\n\t\theight: 8px;\n\t\tborder: 1px solid ', ';\n\t\tbackground-color: ', ';\n\t\tborder-radius: ', ';\n\t}\n']);

var StyledUL = styled('ul')(_templateObject$2, function (props) {
  return props.theme.colours.bodyText;
}, spacing.DOUBLE, spacing.TRIPLE, spacing.DOUBLE);
var BORDER_RADIUS_DIVIDER = 4;
var BORDER_RADIUS_REMAINDER = 3;
var StyledListItem = styled('li')(_templateObject2$1, spacing.SINGLE, colours.neutral.black, function (props) {
  return props.level % 2 > 0 ? colours.neutral.black : 'transparent';
}, function (props) {
  return props.level % BORDER_RADIUS_DIVIDER === BORDER_RADIUS_REMAINDER || props.level % BORDER_RADIUS_DIVIDER === 0 ? '0' : '100%';
});

var processItems = function processItems(items, level) {
  return React.createElement(StyledUL, null, items.map(function (item, index) {
    if (Array.isArray(item)) {
      var newLevel = level;
      newLevel += 1;
      return processItems(item, newLevel);
    }

    return React.createElement(StyledListItem, {
      key: level + '.' + [index],
      level: level
    }, React.createElement(StandardBody, {
      isFlush: true
    }, React.createElement('span', null, item)));
  }));
};

var InternalBulletList = function InternalBulletList(_ref) {
  var items = _ref.items;
  return processItems(items, 1);
};

InternalBulletList.propTypes = {
  /** An array of strings for each item. Can include other arrays for sub items. */
  items: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.node, PropTypes.string])).isRequired
};

var _extends$4 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties$3(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

var GenericIcon$1 = function GenericIcon$1(_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$3(_ref, ["styles"]);

  return React.createElement("svg", _extends$4({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), React.createElement("title", null, "icon-triangleright-large"), React.createElement("path", {
    d: "M16 8L0 16V0"
  }));
};

var _extends$5 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties$4(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

var VMIcon$1 = function VMIcon$1(_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$4(_ref, ["styles"]);

  return React.createElement("svg", _extends$5({
    height: "16",
    viewBox: "0 0 96 96",
    width: "16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), React.createElement("path", {
    d: "M13.75 1.849l68.847 45.515-67.217 47.89"
  }));
};

var getTriangleRightLarge = getThemeIcon(VMIcon$1, GenericIcon$1);

var _templateObject$3 = taggedTemplateLiteral(['\n\t', '\n\tfont-family: ', ';\n\t', ';\n\t', ';\n'], ['\n\t', '\n\tfont-family: ', ';\n\t', ';\n\t', ';\n']);

var getFontProperties$1 = function getFontProperties(props) {
  var fontProperties = 'font-size: 20px; line-height: 1.3;'; // TODOxCYBG To be revisited with responsive VM typography.
  // if (props.theme.name !== 'vm') {

  fontProperties = props.theme.isCompact ? fontSize('jura') : fontSize('arran'); // }

  return fontProperties;
};

var StyledProminentLabel = styled('div')(_templateObject$3, getFontProperties$1, function (props) {
  return props.theme.fonts.display.bold;
}, function (props) {
  return !props.isFlush && 'margin-bottom: ' + spacing.DOUBLE;
}, function (props) {
  return !props.isFlush && 'margin-right: ' + spacing.DOUBLE;
});

var ProminentLabel = function ProminentLabel(_ref) {
  var isFlush = _ref.isFlush,
      children = _ref.children;
  return React.createElement(StyledProminentLabel, {
    isFlush: isFlush
  }, children);
};

ProminentLabel.propTypes = {
  /** Allows for content to be text or node (for example IconTextDynamic). */
  children: PropTypes.node.isRequired,

  /** Removed margins. */
  isFlush: PropTypes.bool
};
ProminentLabel.defaultProps = {
  isFlush: false
};

var _templateObject$4 = taggedTemplateLiteral(['\n\t', '\n\tfont-family: ', ';\n\t', ';\n\t', ';\n'], ['\n\t', '\n\tfont-family: ', ';\n\t', ';\n\t', ';\n']);

var getFontProperties$2 = function getFontProperties(props) {
  var fontProperties = 'font-size: 16px; line-height: 1.5;'; // TODOxCYBG To be revisited with responsive VM typography.
  // if (props.theme.name !== 'vm') {

  fontProperties = props.theme.isCompact ? fontSize('uist') : fontSize('jura'); // }

  return fontProperties;
};

var StyledStandardLabel = styled('div')(_templateObject$4, getFontProperties$2, function (props) {
  return props.theme.fonts.standardLabel;
}, function (props) {
  return !props.isFlush && 'margin-bottom: ' + spacing.DOUBLE;
}, function (props) {
  return !props.isFlush && 'margin-right: ' + spacing.DOUBLE;
});

var StandardLabel = function StandardLabel(_ref) {
  var isFlush = _ref.isFlush,
      children = _ref.children;
  return React.createElement(StyledStandardLabel, {
    isFlush: isFlush
  }, children);
};

StandardLabel.propTypes = {
  /** Allows for content to be text or node (for example IconTextDynamic). */
  children: PropTypes.node.isRequired,

  /** Removed margins. */
  isFlush: PropTypes.bool
};
StandardLabel.defaultProps = {
  isFlush: false
};

var _templateObject$5 = taggedTemplateLiteral(['\n\tbox-sizing: border-box;\n\tmargin-left: 6px;\n\tmax-height: 0;\n\toverflow: hidden;\n\tpadding-left: ', ';\n\tposition: relative;\n\ttransition: all 0.15s;\n\t', ';\n\n\t', ' p:last-child {\n\t\tmargin-bottom: 0;\n\t}\n\n\t:after {\n\t\tbackground-color: ', ';\n\t\tborder-radius: 4px;\n\t\tcontent: \'\';\n\t\tdisplay: block;\n\t\theight: 100%;\n\t\tleft: 0;\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\twidth: 4px;\n\t}\n'], ['\n\tbox-sizing: border-box;\n\tmargin-left: 6px;\n\tmax-height: 0;\n\toverflow: hidden;\n\tpadding-left: ', ';\n\tposition: relative;\n\ttransition: all 0.15s;\n\t', ';\n\n\t', ' p:last-child {\n\t\tmargin-bottom: 0;\n\t}\n\n\t:after {\n\t\tbackground-color: ', ';\n\t\tborder-radius: 4px;\n\t\tcontent: \'\';\n\t\tdisplay: block;\n\t\theight: 100%;\n\t\tleft: 0;\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\twidth: 4px;\n\t}\n']),
    _templateObject2$2 = taggedTemplateLiteral(['\n\talign-items: center;\n\tbackground: none;\n\tborder: none;\n\tcolor: ', ';\n\tdisplay: flex;\n\t', ';\n\tpadding: 0;\n\ttext-decoration: underline;\n\ttransition: margin 0.15s;\n\twidth: 100%;\n\n\t> svg {\n\t\tfill: ', ';\n\t\ttransition: transform 0.15s;\n\t}\n\n\t', ';\n\n\t.buttonLabel {\n\t\tdisplay: flex;\n\t\tmargin-left: ', 'px;\n\t\t', ';\n\t}\n\n\t:focus {\n\t\tbox-shadow: none;\n\n\t\t.buttonLabel {\n\t\t\tborder-radius: ', ';\n\t\t\tbox-shadow: 0 0 0 2px #5d9dd5;\n\t\t\toutline: 0;\n\t\t}\n\t}\n'], ['\n\talign-items: center;\n\tbackground: none;\n\tborder: none;\n\tcolor: ', ';\n\tdisplay: flex;\n\t', ';\n\tpadding: 0;\n\ttext-decoration: underline;\n\ttransition: margin 0.15s;\n\twidth: 100%;\n\n\t> svg {\n\t\tfill: ', ';\n\t\ttransition: transform 0.15s;\n\t}\n\n\t', ';\n\n\t.buttonLabel {\n\t\tdisplay: flex;\n\t\tmargin-left: ', 'px;\n\t\t', ';\n\t}\n\n\t:focus {\n\t\tbox-shadow: none;\n\n\t\t.buttonLabel {\n\t\t\tborder-radius: ', ';\n\t\t\tbox-shadow: 0 0 0 2px #5d9dd5;\n\t\t\toutline: 0;\n\t\t}\n\t}\n']),
    _templateObject3$1 = taggedTemplateLiteral(['\n\t', ';\n'], ['\n\t', ';\n']);

var StyledBodyContent = styled('div')(_templateObject$5, spacing.DOUBLE, function (props) {
  return props.isOpen ? '\n\t\t\t\tanimation: ' + animations.fadeIn + ' 0.7s linear;\n\t\t\t  ' : '\n\t\t\t\tanimation: ' + animations.fadeOut + ' 0.5s linear;\n\t\t\t  ';
}, function (props) {
  return props.isOpen && '\n\t\tmax-height: 4000px;\n\t\toverflow: visible;\n\t\tpadding-bottom: ' + spacing.SINGLE + ';\n\t\tpadding-left: ' + spacing.DOUBLE + ';\n\n\t';
}, function (props) {
  return props.panelColour;
});
var StyledButton = styled('button')(_templateObject2$2, function (props) {
  return props.panelColour;
}, useFontSize.of.jura, function (props) {
  return props.panelColour;
}, function (props) {
  return props.isOpen && !props.hasIconOverride && '\n\t\tmargin-bottom: ' + spacing.DOUBLE + ';\n\n\t\t> svg {\n\t\t\ttransform: rotate(90deg) !important;\n\t\t}\n\t';
}, function (props) {
  return props.isHeadingString ? '6' : '8';
}, function (props) {
  return props.isHeadingString && 'padding: 0 2px;';
}, function (props) {
  return props.theme.borderRadius;
});
var StyledWrapper = styled('div')(_templateObject3$1, function (props) {
  return props.hasAdditionalMarginBottom && 'margin-bottom: ' + spacing.TRIPLE;
});

var InternalContentRevealPanel = function (_Component) {
  inherits(InternalContentRevealPanel, _Component);

  function InternalContentRevealPanel(props) {
    classCallCheck(this, InternalContentRevealPanel);

    var _this = possibleConstructorReturn(this, (InternalContentRevealPanel.__proto__ || Object.getPrototypeOf(InternalContentRevealPanel)).call(this, props));

    var isOpen = props.isOpen;
    _this.state = {
      isOpen: isOpen
    };
    return _this;
  }

  createClass(InternalContentRevealPanel, [{
    key: 'render',
    value: function render() {
      var _this2 = this; // eslint-disable-next-line react/prop-types


      var _props = this.props,
          children = _props.children,
          hasAdditionalMarginBottom = _props.hasAdditionalMarginBottom,
          heading = _props.heading,
          icon = _props.icon,
          panelColour = _props.panelColour,
          theme = _props.theme;
      var isOpen = this.state.isOpen;
      var isHeadingString = typeof heading === 'string';
      var ariaLabel = isHeadingString ? heading.toLowerCase().replace(/\s+/g, '-') : 'content-reveal-panel';
      var TriangleRightLargeIcon = getTriangleRightLarge(theme.name);
      var hasIconOverride = icon !== undefined;
      return React.createElement(StyledWrapper, {
        hasAdditionalMarginBottom: hasAdditionalMarginBottom
      }, React.createElement(StyledButton, {
        'aria-labelledby': ariaLabel,
        isOpen: isOpen,
        hasIconOverride: hasIconOverride,
        onClick: function onClick() {
          return _this2.setState({
            isOpen: !isOpen
          });
        },
        panelColour: panelColour,
        type: 'button'
      }, icon ? icon : React.createElement(TriangleRightLargeIcon, null), React.createElement('div', {
        className: 'buttonLabel'
      }, isHeadingString ? React.createElement(StandardBody, {
        isFlush: true
      }, React.createElement('span', {
        id: ariaLabel
      }, heading)) : heading)), React.createElement(StyledBodyContent, {
        isOpen: isOpen,
        panelColour: panelColour
      }, children));
    }
  }]);
  return InternalContentRevealPanel;
}(Component);

InternalContentRevealPanel.propTypes = {
  /** Content of the panel. */
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,

  /** Heading. */
  heading: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,

  /** Adds additional margin bottom. */
  hasAdditionalMarginBottom: PropTypes.bool,

  /** Sets the initial open state. */
  isOpen: PropTypes.bool,

  /** Sets panel colour. */
  panelColour: PropTypes.string.isRequired
};
InternalContentRevealPanel.defaultProps = {
  hasAdditionalMarginBottom: false,
  isOpen: false
};
var WrappedInternalContentRevealPanel = withTheme(InternalContentRevealPanel);

var _templateObject$6 = taggedTemplateLiteral(['\n\t', ';\n\t', ';\n'], ['\n\t', ';\n\t', ';\n']),
    _templateObject2$3 = taggedTemplateLiteral(['\n\talign-items: flex-end;\n\tbackground-color: ', ';\n\tdisplay: flex;\n\tpadding: 8px;\n\tmargin-bottom: 8px;\n\n\t.internal-frame-basic-details {\n\t\tdisplay: none;\n\t}\n\n\t& > div {\n\t\tmargin-bottom: 0;\n\t}\n\n\tbutton {\n\t\ttext-decoration: none;\n\t}\n\n\tul {\n\t\tmargin-bottom: ', ';\n\t\tmargin-right: ', ';\n\t\tpadding-left: 0;\n\t\tpadding-top: 8px;\n\n\t\tli {\n\t\t\tcolor: white;\n\t\t\ttransform: scale(0.8);\n\n\t\t\t& :before {\n\t\t\t\tbackground-color: ', ';\n\t\t\t\tborder-color: ', ';\n\t\t\t}\n\t\t}\n\t}\n\n\t.blurb {\n\t\tcolor: ', ';\n\t\tmargin-bottom: 8px;\n\t}\n\n\tsvg {\n\t\tfill: ', ' !important;\n\t}\n\n\t.spacer {\n\t\theight: 8px;\n\t}\n'], ['\n\talign-items: flex-end;\n\tbackground-color: ', ';\n\tdisplay: flex;\n\tpadding: 8px;\n\tmargin-bottom: 8px;\n\n\t.internal-frame-basic-details {\n\t\tdisplay: none;\n\t}\n\n\t& > div {\n\t\tmargin-bottom: 0;\n\t}\n\n\tbutton {\n\t\ttext-decoration: none;\n\t}\n\n\tul {\n\t\tmargin-bottom: ', ';\n\t\tmargin-right: ', ';\n\t\tpadding-left: 0;\n\t\tpadding-top: 8px;\n\n\t\tli {\n\t\t\tcolor: white;\n\t\t\ttransform: scale(0.8);\n\n\t\t\t& :before {\n\t\t\t\tbackground-color: ', ';\n\t\t\t\tborder-color: ', ';\n\t\t\t}\n\t\t}\n\t}\n\n\t.blurb {\n\t\tcolor: ', ';\n\t\tmargin-bottom: 8px;\n\t}\n\n\tsvg {\n\t\tfill: ', ' !important;\n\t}\n\n\t.spacer {\n\t\theight: 8px;\n\t}\n']),
    _templateObject3$2 = taggedTemplateLiteral(['\n\tpadding-top: 8px;\n'], ['\n\tpadding-top: 8px;\n']),
    _templateObject4$1 = taggedTemplateLiteral(['\n\tbackground: ', ';\n\toverflow: auto;\n\tpadding: ', ';\n\t', ';\n'], ['\n\tbackground: ', ';\n\toverflow: auto;\n\tpadding: ', ';\n\t', ';\n']),
    _templateObject5$1 = taggedTemplateLiteral(['\n\tbackground-color: hsla(0, 100%, 100%, 80%);\n\tcolor: hsl(0, 0%, 20%);\n\tdisplay: block;\n\tpadding-left: ', ';\n\tfont-size: ', ';\n'], ['\n\tbackground-color: hsla(0, 100%, 100%, 80%);\n\tcolor: hsl(0, 0%, 20%);\n\tdisplay: block;\n\tpadding-left: ', ';\n\tfont-size: ', ';\n']),
    _templateObject6$1 = taggedTemplateLiteral(['\n\tbackground-color: hsla(0, 100%, 100%, 80%);\n\tdisplay: flex;\n\tpadding: 8px 16px 0px 8px;\n'], ['\n\tbackground-color: hsla(0, 100%, 100%, 80%);\n\tdisplay: flex;\n\tpadding: 8px 16px 0px 8px;\n']);

var BasicComponentWrapper = styled('div')(_templateObject$6, function (props) {
  return !props.removeFrameMargins && externalMarginRegular;
}, function (props) {
  return props.isInline && 'display: inline-block;';
});
var InfoContainer = styled('div')(_templateObject2$3, function (props) {
  return props.content;
}, spacing.DOUBLE, spacing.DOUBLE, colours.neutral.white, colours.neutral.white, colours.neutral.white, colours.neutral.white);
var InfoContentWrapper = styled('div')(_templateObject3$2);
var XRayComponentWrapper = styled('div')(_templateObject4$1, function (props) {
  return props.background;
}, function (props) {
  return props.isContainter ? '0' : '8px 16px 16px 8px';
}, function (props) {
  return props.isContainter && 'margin-bottom: 8px';
});
var basePropTypes = {
  children: PropTypes.node,
  componentName: PropTypes.string.isRequired,
  hasCustomMargins: PropTypes.bool,
  isFlush: PropTypes.bool,
  isInline: PropTypes.bool
};

var ActiveComponent = function ActiveComponent(_ref) {
  var children = _ref.children,
      componentName = _ref.componentName,
      hasCustomMargins = _ref.hasCustomMargins,
      isFlush = _ref.isFlush,
      isInline = _ref.isInline,
      xraySuppressed = _ref.xraySuppressed;
  var _colours$component$fr = colours.component.frame.active,
      background = _colours$component$fr.background,
      content = _colours$component$fr.content;
  var _window = window,
      XrayHelper = _window.XrayHelper;

  if (xraySuppressed || XrayHelper && XrayHelper.checkIsXrayMode() === false) {
    return React.createElement(BasicComponentWrapper, {
      isInline: isInline,
      removeFrameMargins: hasCustomMargins || isFlush
    }, children);
  }

  return React.createElement('div', null, React.createElement(XRayComponentWrapper, {
    background: background
  }, children), React.createElement(InfoContainer, {
    content: content
  }, React.createElement(WrappedInternalContentRevealPanel, {
    panelColour: 'white',
    heading: 'Active Component: ' + componentName
  }, React.createElement(InfoContentWrapper, null, React.createElement('span', {
    className: 'blurb'
  }, 'Details on this component can be found in web-ui-components styleguide.')))));
};

ActiveComponent.propTypes = _extends$1({}, basePropTypes, {
  xraySuppressed: PropTypes.bool
});
ActiveComponent.defaultProps = {
  hasCustomMargins: false,
  isFlush: false,
  xraySuppressed: false
};
var BasicDetails = styled('span')(_templateObject5$1, function (props) {
  return props.padding;
}, function (props) {
  return props.fontSize;
});

var ActiveInline = function ActiveInline(_ref2) {
  var children = _ref2.children,
      componentName = _ref2.componentName,
      hasCustomMargins = _ref2.hasCustomMargins,
      isFlush = _ref2.isFlush,
      xraySuppressed = _ref2.xraySuppressed;
  var content = colours.component.frame.active.content;
  var _window2 = window,
      XrayHelper = _window2.XrayHelper;

  if (xraySuppressed || XrayHelper && XrayHelper.checkIsXrayMode() === false) {
    return React.createElement(BasicComponentWrapper, {
      isInline: true,
      removeFrameMargins: hasCustomMargins || isFlush
    }, children);
  }

  return React.createElement('div', null, children, React.createElement('div', {
    className: 'internal-frame-basic-details'
  }, React.createElement(BasicDetails, {
    content: content,
    fontSize: '0.6em',
    padding: '2px'
  }, React.createElement('b', null, 'Active Component:'), ' ', componentName)));
};

ActiveInline.propTypes = _extends$1({}, basePropTypes, {
  xraySuppressed: PropTypes.bool
});
ActiveInline.defaultProps = {
  hasCustomMargins: false,
  isFlush: false,
  isSuppressed: false
};

var ActiveTypography = function ActiveTypography(_ref3) {
  var children = _ref3.children,
      componentName = _ref3.componentName,
      hasCustomMargins = _ref3.hasCustomMargins,
      isFlush = _ref3.isFlush,
      xraySuppressed = _ref3.xraySuppressed;
  var content = colours.component.frame.active.content;
  var _window3 = window,
      XrayHelper = _window3.XrayHelper;

  if (xraySuppressed || XrayHelper && XrayHelper.checkIsXrayMode() === false) {
    return React.createElement(BasicComponentWrapper, {
      removeFrameMargins: hasCustomMargins || isFlush
    }, children);
  }

  return React.createElement('div', null, children, React.createElement('div', {
    className: 'internal-frame-basic-details'
  }, React.createElement(BasicDetails, {
    content: content,
    fontSize: '0.6em',
    padding: '2px'
  }, React.createElement('b', null, 'Active Component:'), ' ', componentName)));
};

ActiveTypography.propTypes = _extends$1({}, basePropTypes, {
  xraySuppressed: PropTypes.bool
});
ActiveTypography.defaultProps = {
  hasCustomMargins: false,
  isFlush: false,
  isSuppressed: false
};
var InnerContainer = styled('div')(_templateObject6$1);

var ActiveContainer = function ActiveContainer(_ref4) {
  var children = _ref4.children,
      componentName = _ref4.componentName,
      hasCustomMargins = _ref4.hasCustomMargins,
      isFlush = _ref4.isFlush,
      xraySuppressed = _ref4.xraySuppressed;
  var _colours$component$fr2 = colours.component.frame.active,
      background = _colours$component$fr2.background,
      content = _colours$component$fr2.content;
  var _window4 = window,
      XrayHelper = _window4.XrayHelper;

  if (xraySuppressed || XrayHelper && XrayHelper.checkIsXrayMode() === false) {
    return React.createElement(BasicComponentWrapper, {
      removeFrameMargins: hasCustomMargins || isFlush
    }, children);
  }

  return React.createElement('div', null, React.createElement(XRayComponentWrapper, {
    background: background,
    isContainter: true
  }, React.createElement(InnerContainer, null, children), React.createElement('div', {
    className: 'internal-frame-basic-details'
  }, React.createElement(BasicDetails, {
    content: content,
    fontSize: '0.8em',
    padding: '10px'
  }, React.createElement('b', null, 'Active Component:'), ' ', componentName))));
};

ActiveContainer.propTypes = _extends$1({}, basePropTypes, {
  xraySuppressed: PropTypes.bool
});
ActiveContainer.defaultProps = {
  hasCustomMargins: false,
  isFlush: false,
  xraySuppressed: false
};

var Deprecated = function Deprecated(_ref5) {
  var children = _ref5.children,
      componentName = _ref5.componentName,
      hasCustomMargins = _ref5.hasCustomMargins,
      isFlush = _ref5.isFlush,
      isInline = _ref5.isInline;
  DeprecationWarnings.logComponent(componentName);
  var _window5 = window,
      XrayHelper = _window5.XrayHelper;

  if (XrayHelper && XrayHelper.checkIsXrayMode() === false) {
    return React.createElement(BasicComponentWrapper, {
      isInline: isInline,
      removeFrameMargins: hasCustomMargins || isFlush
    }, children);
  }

  var _colours$component$fr3 = colours.component.frame.deprecated,
      background = _colours$component$fr3.background,
      content = _colours$component$fr3.content;
  return React.createElement('div', null, React.createElement(XRayComponentWrapper, {
    background: background
  }, children), React.createElement(InfoContainer, {
    content: content
  }, React.createElement(WrappedInternalContentRevealPanel, {
    panelColour: 'white',
    heading: 'Deprecated Component: ' + componentName
  }, React.createElement(InfoContentWrapper, null, React.createElement('span', null, React.createElement('p', {
    className: 'blurb'
  }, 'This component is deprecated.'), React.createElement('p', {
    className: 'blurb'
  }, 'See styleguide for details.')), React.createElement('p', {
    className: 'blurb'
  }, 'Deprecated components are no longer tested via:'), React.createElement(InternalBulletList, {
    items: ['Visual regression & brand testing.', 'Integration testing.', 'Manual input testing.', 'Accessibility testing.']
  }), React.createElement('span', {
    className: 'blurb'
  }, React.createElement('b', null, React.createElement('u', null, 'Upgrade as soon as possible.'))))), React.createElement('div', {
    className: 'spacer'
  })));
};

Deprecated.propTypes = _extends$1({}, basePropTypes);
Deprecated.defaultProps = {
  isFlush: false,
  isInline: false,
  hasCustomMargins: false
};

var Draft = function Draft(_ref6) {
  var children = _ref6.children,
      componentName = _ref6.componentName,
      hasCustomMargins = _ref6.hasCustomMargins,
      isFlush = _ref6.isFlush,
      xraySuppressed = _ref6.xraySuppressed;
  var _colours$component$fr4 = colours.component.frame.draft,
      background = _colours$component$fr4.background,
      content = _colours$component$fr4.content;
  var _window6 = window,
      XrayHelper = _window6.XrayHelper;

  if (xraySuppressed || XrayHelper && XrayHelper.checkIsXrayMode() === false) {
    return React.createElement(BasicComponentWrapper, {
      removeFrameMargins: hasCustomMargins || isFlush
    }, children);
  }

  return React.createElement('div', null, React.createElement(XRayComponentWrapper, {
    background: background
  }, children), React.createElement(InfoContainer, {
    content: content
  }, React.createElement(WrappedInternalContentRevealPanel, {
    panelColour: 'white',
    heading: 'Draft Component: ' + componentName
  }, React.createElement(InfoContentWrapper, null, React.createElement('p', {
    className: 'blurb'
  }, 'This component is in draft stage.'), React.createElement('p', {
    className: 'blurb'
  }, 'Do not log defects for:'), React.createElement(InternalBulletList, {
    items: ['Appearance or styles.', 'Keyboard or mouse behaviours.', 'Missing input validations.'],
    isFlush: true
  }), React.createElement('span', {
    className: 'blurb'
  }, 'Upgrade before using in production.'))), React.createElement('div', {
    className: 'spacer'
  })));
};

Draft.propTypes = _extends$1({}, basePropTypes, {
  xraySuppressed: PropTypes.bool
});
Draft.defaultProps = {
  hasCustomMargins: false,
  isFlush: false,
  xraySuppressed: false
};

var Outdated = function Outdated(_ref7) {
  var children = _ref7.children,
      componentName = _ref7.componentName,
      hasCustomMargins = _ref7.hasCustomMargins,
      isFlush = _ref7.isFlush,
      isInline = _ref7.isInline;
  var _colours$component$fr5 = colours.component.frame.outdated,
      background = _colours$component$fr5.background,
      content = _colours$component$fr5.content;
  var _window7 = window,
      XrayHelper = _window7.XrayHelper;

  if (XrayHelper && XrayHelper.checkIsXrayMode() === false) {
    return React.createElement(BasicComponentWrapper, {
      isInline: isInline,
      removeFrameMargins: hasCustomMargins || isFlush
    }, children);
  }

  return React.createElement('div', null, React.createElement(XRayComponentWrapper, {
    background: background
  }, children), React.createElement(InfoContainer, {
    content: content
  }, React.createElement(WrappedInternalContentRevealPanel, {
    panelColour: 'white',
    heading: 'Outdated Component: ' + componentName
  }, React.createElement(InfoContentWrapper, null, React.createElement('p', {
    className: 'blurb'
  }, 'This component is outdated.'), React.createElement('p', {
    className: 'blurb'
  }, 'It should not be used in newer project work'), React.createElement('p', {
    className: 'blurb'
  }, 'It may have issues with:'), React.createElement(InternalBulletList, {
    items: ['Accessibility.', 'Consistency.', 'Optimisation.'],
    isFlush: true
  }), React.createElement('span', {
    className: 'blurb'
  }, 'Before adding to a new codebase, contact the UI team about seeking a replacement.'))), React.createElement('div', {
    className: 'spacer'
  })));
};

Outdated.propTypes = _extends$1({}, basePropTypes);
Outdated.defaultProps = {
  hasCustomMargins: false
};
var InternalComponentFrame = {
  ActiveComponent: ActiveComponent,
  ActiveContainer: ActiveContainer,
  ActiveInline: ActiveInline,
  ActiveTypography: ActiveTypography,
  Deprecated: Deprecated,
  Draft: Draft,
  Outdated: Outdated
};

var _templateObject$7 = taggedTemplateLiteral(['\n\tmargin-right: ', ';\n\n\tsvg {\n\t\tfill: ', ';\n\t\theight: 24px;\n\t\twidth: 24px;\n\t}\n'], ['\n\tmargin-right: ', ';\n\n\tsvg {\n\t\tfill: ', ';\n\t\theight: 24px;\n\t\twidth: 24px;\n\t}\n']),
    _templateObject2$4 = taggedTemplateLiteral(['\n\talign-items: center;\n\tbackground: ', ';\n\tborder: 1px solid ', ';\n\tborder-radius: ', ';\n\tdisplay: inline-flex;\n\tpadding: ', ' ', ';\n\tposition: fixed;\n\tright: ', ';\n\ttop: ', ';\n\n\ttransition: right 0.5s ease-in-out;\n'], ['\n\talign-items: center;\n\tbackground: ', ';\n\tborder: 1px solid ', ';\n\tborder-radius: ', ';\n\tdisplay: inline-flex;\n\tpadding: ', ' ', ';\n\tposition: fixed;\n\tright: ', ';\n\ttop: ', ';\n\n\ttransition: right 0.5s ease-in-out;\n']);

var StyledIconWrapper = styled$1('div')(_templateObject$7, spacing.SINGLE, function (props) {
  return props.iconColour;
});
var StyledWrapper$1 = styled$1('div')(_templateObject2$4, colours.backgrounds.component, function (props) {
  return props.borderColour;
}, function (props) {
  return props.theme.borderRadiusLarger;
}, spacing.DOUBLE, spacing.TRIPLE, function (props) {
  return props.isVisible ? spacing.DOUBLE : '-100%';
}, spacing.DOUBLE);

var BaseToast = function BaseToast(_ref) {
  var borderColour = _ref.borderColour,
      icon = _ref.icon,
      iconColour = _ref.iconColour,
      isVisible = _ref.isVisible,
      messageText = _ref.messageText;
  return React.createElement(StyledWrapper$1, {
    borderColour: borderColour,
    isVisible: isVisible
  }, icon && React.createElement(StyledIconWrapper, {
    iconColour: iconColour
  }, icon), React.createElement(ProminentLabel, {
    isFlush: true
  }, React.createElement('span', null, messageText)));
};

BaseToast.propTypes = {
  /** Border colour. */
  borderColour: PropTypes.string,

  /** Icon shown to the left of the message text. */
  icon: PropTypes.node,

  /** Icon fill colour. */
  iconColour: PropTypes.string,

  /** Character count as number. */
  isVisible: PropTypes.bool.isRequired,

  /** Message text. */
  messageText: PropTypes.string.isRequired
};
BaseToast.defaultProps = {
  borderColour: 'hsl(0, 0%, 0%)'
};

var InternalLockedToast = function InternalLockedToast(_ref) {
  var isVisible = _ref.isVisible,
      theme = _ref.theme;
  var PadlockIcon = getLockOutlineLarge(theme.name);
  return React.createElement(BaseToast, {
    borderColour: colours.component.locked,
    icon: React.createElement(PadlockIcon, null),
    iconColour: colours.component.locked,
    isVisible: isVisible,
    messageText: 'Feature is locked.'
  });
};

InternalLockedToast.propTypes = {
  /** Makes the toast visible. */
  isVisible: PropTypes.bool.isRequired
};
InternalLockedToast.defaultProps = {
  borderColour: 'hsl(0, 0%, 0%)'
};
var WrappedInternalLockedToast = withTheme(InternalLockedToast);
var INTERNET_BANKING_CSS_OVERRIDE = '!important';

var _templateObject$8 = taggedTemplateLiteral(['\n\tsvg {\n\t\t', '\n\t\tfill: ', ';\n\t\theight: 24px;\n\t\tmargin-right: 8px;\n\t\ttransition: fill 0.2s ease-in-out;\n\t\twidth: 24px;\n}\n'], ['\n\tsvg {\n\t\t', '\n\t\tfill: ', ';\n\t\theight: 24px;\n\t\tmargin-right: 8px;\n\t\ttransition: fill 0.2s ease-in-out;\n\t\twidth: 24px;\n}\n']),
    _templateObject2$5 = taggedTemplateLiteral(['\n\tdisplay: inline-flex;\n\tmargin-left: 4px;\n\n\t> svg {\n\t\tfill: ', ';\n\t\theight: 16px;\n\t\tmargin-right: 0;\n\t\twidth: 16px;\n\t}\n'], ['\n\tdisplay: inline-flex;\n\tmargin-left: 4px;\n\n\t> svg {\n\t\tfill: ', ';\n\t\theight: 16px;\n\t\tmargin-right: 0;\n\t\twidth: 16px;\n\t}\n']),
    _templateObject3$3 = taggedTemplateLiteral(['\n\talign-items: center;\n\tborder-radius: ', ';\n\tbox-sizing: border-box;\n\tcursor: pointer;\n\tdisplay: inline-flex;\n\theight: ', ';\n\t', '\n\tmax-width: 100%;\n\tpadding: 0 ', ';\n\ttransition: all 0.15s;\n\ttext-align: left;\n\t', '\n\t', '\n\t', '\n\t', ';\n'], ['\n\talign-items: center;\n\tborder-radius: ', ';\n\tbox-sizing: border-box;\n\tcursor: pointer;\n\tdisplay: inline-flex;\n\theight: ', ';\n\t', '\n\tmax-width: 100%;\n\tpadding: 0 ', ';\n\ttransition: all 0.15s;\n\ttext-align: left;\n\t', '\n\t', '\n\t', '\n\t', ';\n']);

var getPrimaryHoverStyles = function getPrimaryHoverStyles(props) {
  if (!props.isLoading && !props.isLocked) {
    return '&:hover {\n\t\t\tbackground-color: ' + props.theme.colours.secondaryAccent + ';\n\t\t\tborder-color: ' + props.theme.colours.secondaryAccent + ';\n\t\t}';
  }

  return '';
};

var getPrimaryBackgroundColour = function getPrimaryBackgroundColour(props) {
  var colour = props.theme.colours.primary;

  if (props.isLoading) {
    colour = props.theme.colours.disabledNavigationButton;
  } else if (props.isLocked) {
    colour = colours.component.locked;
  }

  return colour;
};

var primaryStyles = function primaryStyles(props) {
  return '\n\tbackground-color: ' + getPrimaryBackgroundColour(props) + ';\n\tborder: 2px solid ' + getPrimaryBackgroundColour(props) + ';\n\tborder-bottom-color: ' + (props.isLoading ? props.theme.colours.disabledNavigationButton : !props.isLocked && props.theme.colours.secondaryAccent) + ';\n\tcolor: ' + colours.neutral.white + ';\n\t' + getPrimaryHoverStyles(props) + '\n';
};

var getSecondaryHoverStyles = function getSecondaryHoverStyles(props) {
  if (!props.isLoading && !props.isLocked) {
    return '&:hover {\n            background-color: ' + props.theme.colours.primary + ';\n            color: ' + colours.neutral.white + ';\n\t\t}';
  }

  return '';
};

var getSecondaryBackgroundColour = function getSecondaryBackgroundColour(props) {
  var colour = colours.neutral.white;

  if (props.isLoading) {
    colour = props.theme.colours.disabledNavigationButton;
  } else if (props.isLocked) {
    colour = colours.component.locked;
  }

  return colour;
};

var getSecondaryBorderColour = function getSecondaryBorderColour(props) {
  var colour = props.theme.colours.primary;

  if (props.isLoading) {
    colour = props.theme.colours.disabledNavigationButton;
  } else if (props.isLocked) {
    colour = colours.component.locked;
  }

  return colour;
};

var secondaryStyles = function secondaryStyles(props) {
  return '\n\tbackground-color: ' + getSecondaryBackgroundColour(props) + ';\n\tborder: 2px solid ' + getSecondaryBorderColour(props) + ';\n\tcolor: ' + (props.isLoading || props.isLocked ? colours.neutral.white : props.theme.colours.primary) + ';\n\t' + getSecondaryHoverStyles(props) + '\n';
};

var getTertiaryHoverStyles = function getTertiaryHoverStyles(props) {
  if (!props.isLoading && !props.isLocked) {
    return '&:hover {\n            color: ' + props.theme.colours.secondaryAccent + ';\n\t\t}';
  }

  return '';
};

var tertiaryStyles = function tertiaryStyles(props) {
  return '\n\tbackground: none;\n\tborder: 0;\n\tcolor: ' + (props.isLocked ? colours.component.locked : props.theme.colours.primary) + ';\n\tpadding: 0;\n\ttext-decoration: underline;\n\n\t> div {\n\t\tfont-family: ' + props.theme.fonts.text.regular + ';\n\t}\n\n\t' + getTertiaryHoverStyles(props) + '\n';
};

var StyledLoadingIcon = styled('div')(_templateObject$8, function (props) {
  return props.isLoading && 'animation: spin 0.75s linear infinite;';
}, function (props) {
  return props.displayType === 'primary' || props.isLoading ? colours.neutral.white : props.theme.colours.primary;
});
var StyledPadlockIcon = styled('div')(_templateObject2$5, function (props) {
  return props.displayType !== 'tertiary' ? colours.neutral.white : colours.component.locked;
});
var StyledButton$1 = styled('button')(_templateObject3$3, function (props) {
  return props.theme.borderRadius;
}, spacing.SEXTUPLE, function (props) {
  return !props.isInline && 'margin-bottom: 1rem; margin-right: 1.5rem ' + INTERNET_BANKING_CSS_OVERRIDE + ';';
}, spacing.TRIPLE, function (props) {
  return props.displayType === 'primary' && primaryStyles(props);
}, function (props) {
  return props.displayType === 'secondary' && secondaryStyles(props);
}, function (props) {
  return props.displayType === 'tertiary' && tertiaryStyles(props);
}, function (props) {
  return props.hasFluidHeight && 'height: auto';
});

var getLabelText = function getLabelText(label, labelText) {
  if (label === undefined) {
    return labelText;
  }

  DeprecationWarnings.logProp('NavigationButton', 'Navigation → Buttons → NavigationButton', 'label prop deprecated in favour of labelText prop.');
  return label;
}; // eslint-disable-next-line react/prop-types


var UnwrappedBase = function (_Component) {
  inherits(UnwrappedBase, _Component);

  function UnwrappedBase(props) {
    classCallCheck(this, UnwrappedBase);

    var _this = possibleConstructorReturn(this, (UnwrappedBase.__proto__ || Object.getPrototypeOf(UnwrappedBase)).call(this, props));

    _this.state = {
      isVisible: false
    };
    return _this;
  }

  createClass(UnwrappedBase, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          display = _props.display,
          hasFluidHeight = _props.hasFluidHeight,
          isInline = _props.isInline,
          isLoading = _props.isLoading,
          isLocked = _props.isLocked,
          labelText = _props.labelText,
          loadingText = _props.loadingText,
          onClick = _props.onClick,
          theme = _props.theme,
          willSubmitForm = _props.willSubmitForm;
      var isVisible = this.state.isVisible;
      var PadlockIcon = getLockOutlineLarge(theme.name);
      var threeSeconds = 3000;

      var popToast = function popToast() {
        _this2.setState(function () {
          return {
            isVisible: true
          };
        }); // Load data / make the call. Spoofed here for demo purposes.


        setTimeout(function () {
          _this2.setState(function () {
            return {
              isVisible: false
            };
          });
        }, threeSeconds);
      };

      return React.createElement(InternalComponentFrame.ActiveComponent, {
        componentName: 'NavigationButton',
        hasCustomMargins: true,
        isInline: true
      }, React.createElement(StyledButton$1, {
        disabled: isLoading,
        displayType: display,
        hasFluidHeight: hasFluidHeight,
        isInline: isInline,
        isLoading: isLoading,
        isLocked: isLocked,
        loadingText: true,
        onClick: isLocked ? popToast : onClick,
        type: willSubmitForm ? 'submit' : 'button'
      }, isLoading && React.createElement(StyledLoadingIcon, {
        isLoading: isLoading
      }, React.createElement(LoadingOutlineSmallIcon, null)), React.createElement(StandardLabel, {
        isFlush: true
      }, React.createElement('span', null, isLoading ? loadingText : labelText)), isLocked && React.createElement(StyledPadlockIcon, {
        displayType: display,
        isLocked: isLocked
      }, React.createElement(PadlockIcon, null))), React.createElement(WrappedInternalLockedToast, {
        isVisible: isVisible
      }));
    }
  }]);
  return UnwrappedBase;
}(Component);

var Base = withTheme(UnwrappedBase);

var Back = function Back(_ref) {
  var isLoading = _ref.isLoading,
      loadingText = _ref.loadingText,
      onClick = _ref.onClick;
  return React.createElement(Base, {
    display: 'secondary',
    isLoading: isLoading,
    labelText: 'Back',
    loadingText: loadingText,
    onClick: onClick
  });
};

var Cancel = function Cancel(_ref2) {
  var onClick = _ref2.onClick;
  return React.createElement(Base, {
    display: 'tertiary',
    labelText: 'Cancel',
    onClick: onClick
  });
};

var Confirm = function Confirm(_ref3) {
  var isLoading = _ref3.isLoading,
      isLocked = _ref3.isLocked,
      loadingText = _ref3.loadingText,
      onClick = _ref3.onClick,
      willSubmitForm = _ref3.willSubmitForm;
  return React.createElement(Base, {
    display: 'primary',
    isLoading: isLoading,
    isLocked: isLocked,
    labelText: 'Confirm',
    loadingText: loadingText,
    onClick: onClick,
    willSubmitForm: willSubmitForm
  });
};

var Continue = function Continue(_ref4) {
  var isLoading = _ref4.isLoading,
      isLocked = _ref4.isLocked,
      loadingText = _ref4.loadingText,
      onClick = _ref4.onClick,
      willSubmitForm = _ref4.willSubmitForm;
  return React.createElement(Base, {
    display: 'primary',
    isLoading: isLoading,
    isLocked: isLocked,
    labelText: 'Continue',
    loadingText: loadingText,
    onClick: onClick,
    willSubmitForm: willSubmitForm
  });
};

var Next = function Next(_ref5) {
  var isLoading = _ref5.isLoading,
      isLocked = _ref5.isLocked,
      loadingText = _ref5.loadingText,
      onClick = _ref5.onClick,
      willSubmitForm = _ref5.willSubmitForm;
  return React.createElement(Base, {
    display: 'primary',
    isLoading: isLoading,
    isLocked: isLocked,
    labelText: 'Next',
    loadingText: loadingText,
    onClick: onClick,
    willSubmitForm: willSubmitForm
  });
};

var Primary = function Primary(_ref6) {
  var isLoading = _ref6.isLoading,
      isLocked = _ref6.isLocked,
      loadingText = _ref6.loadingText,
      label = _ref6.label,
      labelText = _ref6.labelText,
      onClick = _ref6.onClick,
      willSubmitForm = _ref6.willSubmitForm;
  var textLabel = getLabelText(label, labelText);
  return React.createElement(Base, {
    display: 'primary',
    isLoading: isLoading,
    isLocked: isLocked,
    labelText: textLabel,
    loadingText: loadingText,
    onClick: onClick,
    willSubmitForm: willSubmitForm
  });
};

var Secondary = function Secondary(_ref7) {
  var isLoading = _ref7.isLoading,
      isLocked = _ref7.isLocked,
      loadingText = _ref7.loadingText,
      label = _ref7.label,
      labelText = _ref7.labelText,
      onClick = _ref7.onClick;
  var textLabel = getLabelText(label, labelText);
  return React.createElement(Base, {
    display: 'secondary',
    isLoading: isLoading,
    isLocked: isLocked,
    labelText: textLabel,
    loadingText: loadingText,
    onClick: onClick
  });
};

var Submit = function Submit(_ref8) {
  var isLoading = _ref8.isLoading,
      isLocked = _ref8.isLocked,
      loadingText = _ref8.loadingText,
      onClick = _ref8.onClick,
      willSubmitForm = _ref8.willSubmitForm;
  return React.createElement(Base, {
    display: 'primary',
    isLoading: isLoading,
    isLocked: isLocked,
    labelText: 'Submit',
    loadingText: loadingText,
    onClick: onClick,
    willSubmitForm: willSubmitForm
  });
};

var Tertiary = function Tertiary(_ref9) {
  var isInline = _ref9.isInline,
      isLocked = _ref9.isLocked,
      label = _ref9.label,
      labelText = _ref9.labelText,
      onClick = _ref9.onClick,
      willSubmitForm = _ref9.willSubmitForm;
  var textLabel = getLabelText(label, labelText);
  return React.createElement(Base, {
    display: 'tertiary',
    hasFluidHeight: true,
    isInline: isInline,
    isLocked: isLocked,
    labelText: textLabel,
    onClick: onClick,
    willSubmitForm: willSubmitForm
  });
};

var baseProps = {
  /** Locks the component. */
  isLocked: PropTypes.bool,

  /** Callback function triggered on click. */
  onClick: PropTypes.func.isRequired
};

var primaryVariantProps = _extends$1({}, baseProps, {
  /** Shows the loading spinner and loading text when true. */
  isLoading: PropTypes.bool,

  /** Sets the text when the isLoading prop is set to true. */
  loadingText: PropTypes.string,

  /** Changes button type from 'button' to 'submit'. */
  willSubmitForm: PropTypes.bool
});

var secondaryVariantProps = _extends$1({}, baseProps, {
  /** Shows the loading spinner and loading text when true. */
  isLoading: PropTypes.bool,

  /** Sets the text when the isLoading prop is set to true. */
  loadingText: PropTypes.string
});

var tertiaryVariantProps = _extends$1({}, baseProps, {
  /** Removed margins. */
  isInline: PropTypes.bool
});

Base.propTypes = {
  /** Callback function triggered on click. */
  onClick: PropTypes.func.isRequired,

  /** Sets the display type, controls the styling. */
  display: PropTypes.oneOf(['primary', 'secondary', 'tertiary']).isRequired,

  /** Boolean to override the static button height. */
  hasFluidHeight: PropTypes.bool,

  /** Removed margins. */
  isInline: PropTypes.bool,

  /** Shows the loading spinner and loading text when true. */
  isLoading: PropTypes.bool,

  /** Button text. */
  labelText: PropTypes.string.isRequired,

  /** Sets the text when the isLoading prop is set to true. */
  loadingText: PropTypes.string,

  /** When set, will change button type from 'button' to 'submit'. */
  willSubmitForm: PropTypes.bool
};
Base.defaultProps = {
  hasFluidHeight: false,
  isInline: false,
  isLoading: false,
  isLocked: false,
  loadingText: 'Loading',
  willSubmitForm: false
};
Back.propTypes = _extends$1({}, secondaryVariantProps);
Cancel.propTypes = _extends$1({}, tertiaryVariantProps);
Confirm.propTypes = _extends$1({}, primaryVariantProps);
Continue.propTypes = _extends$1({}, primaryVariantProps);
Next.propTypes = _extends$1({}, primaryVariantProps);
Primary.propTypes = _extends$1({}, primaryVariantProps, {
  /** Button text. */
  label: PropTypes.string,
  labelText: PropTypes.string.isRequired
});
Secondary.propTypes = _extends$1({}, secondaryVariantProps, {
  /** Button text. */
  label: PropTypes.string,
  labelText: PropTypes.string.isRequired
});
Submit.propTypes = _extends$1({}, primaryVariantProps);
Tertiary.propTypes = _extends$1({}, tertiaryVariantProps, {
  /** Button text. */
  label: PropTypes.string,
  labelText: PropTypes.string.isRequired
});

var exampleHandler = function exampleHandler() {};

Back.defaultExample = function () {
  return React.createElement(Back, {
    onClick: exampleHandler
  });
};

Cancel.defaultExample = function () {
  return React.createElement(Cancel, {
    onClick: exampleHandler
  });
};

Confirm.defaultExample = function () {
  return React.createElement(Confirm, {
    onClick: exampleHandler
  });
};

Continue.defaultExample = function () {
  return React.createElement(Continue, {
    onClick: exampleHandler
  });
};

Next.defaultExample = function () {
  return React.createElement(Next, {
    onClick: exampleHandler
  });
};

Primary.defaultExample = function () {
  return React.createElement(Primary, {
    labelText: 'Button label',
    onClick: exampleHandler
  });
};

Secondary.defaultExample = function () {
  return React.createElement(Secondary, {
    labelText: 'Button label',
    onClick: exampleHandler
  });
};

Submit.defaultExample = function () {
  return React.createElement(Submit, {
    onClick: exampleHandler
  });
};

Tertiary.defaultExample = function () {
  return React.createElement(Tertiary, {
    labelText: 'Button label',
    onClick: exampleHandler
  });
};

var NavigationButton = {
  Back: Back,
  Cancel: Cancel,
  Confirm: Confirm,
  Continue: Continue,
  Next: Next,
  Primary: Primary,
  Secondary: Secondary,
  Submit: Submit,
  Tertiary: Tertiary
};

var _templateObject$9 = taggedTemplateLiteral(['\n\tdisplay: flex;\n\tflex-wrap: wrap;\n'], ['\n\tdisplay: flex;\n\tflex-wrap: wrap;\n']),
    _templateObject2$6 = taggedTemplateLiteral(['\n\tdisplay: flex;\n\tflex-basis: 100%;\n'], ['\n\tdisplay: flex;\n\tflex-basis: 100%;\n']);

var StyledWrapper$2 = styled('div')(_templateObject$9);
var StyledTertiaryButtons = styled('div')(_templateObject2$6);

var NavigationButtonGroup = function NavigationButtonGroup(_ref) {
  var primaryButton = _ref.primaryButton,
      secondaryButtons = _ref.secondaryButtons,
      tertiaryButtons = _ref.tertiaryButtons;
  return React.createElement(InternalComponentFrame.ActiveContainer, {
    componentName: 'NavigationButtonGroup',
    hasCustomMargins: true
  }, React.createElement(StyledWrapper$2, null, secondaryButtons, primaryButton, tertiaryButtons && React.createElement(StyledTertiaryButtons, null, tertiaryButtons)));
};

NavigationButtonGroup.propTypes = {
  /** Primary button child. Should be a <NavigationButton.Variant> component of primary style. */
  primaryButton: PropTypes.node.isRequired,

  /** Secondary buttons, either as a single <NavigationButton.Variant> component, or an array of the same. */
  secondaryButtons: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]).isRequired,

  /** Tertiary buttons, either as a single <NavigationButton.Variant> component, or an array of the same. */
  tertiaryButtons: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)])
};
NavigationButtonGroup.defaultProps = {};

NavigationButtonGroup.defaultExample = function () {
  return React.createElement(NavigationButtonGroup, {
    primaryButton: React.createElement(NavigationButton.Next, {
      onClick: function onClick() {}
    }),
    secondaryButtons: React.createElement(NavigationButton.Back, {
      onClick: function onClick() {}
    })
  });
};

export { NavigationButton, NavigationButtonGroup };